<template lang="html">
  <div>
    <h4><u>PRIMERA. Objeto</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>EL objeto del presente Anexo es establecer los t&eacute;rminos y condiciones generales conforme a los cuales se regir&aacute; la prestaci&oacute;n de los Servicios de MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO que Alt&aacute;n proporcionar&aacute; al</li>
<li>El alcance t&eacute;cnico, t&eacute;rminos y condiciones comerciales y Plan de Proyecto conforme a los cuales se prestar&aacute;n los Servicios de MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO se describen y establecen en los siguientes Ap&eacute;ndices:</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Ap&eacute;ndice 11.1 &ldquo;Alcance T&eacute;cnico MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</li>
<li>Ap&eacute;ndice 11.2 &ldquo;T&eacute;rminos Comerciales y Estructuras Tarifarias MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</li>
<li>Ap&eacute;ndice 11.3 &ldquo;Tarifas MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</li>
<li>Ap&eacute;ndice 11.4 &ldquo;Plan de Proyecto e Implementaci&oacute;n MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</li>
<li>Ap&eacute;ndice 11.5. &ldquo;Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</li>
<li>Ap&eacute;ndice 11.6 &ldquo;Proyecciones MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</li>
<li>Ap&eacute;ndice 11.7 &ldquo;Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;</li>
</ul>
<p>&nbsp;</p>
<h4><u>SEGUNDA. Vigencia</u></h4>
<p><strong>&nbsp;</strong></p>
<p>Salvo que se d&eacute; por terminado de manera anticipada de conformidad con los t&eacute;rminos del Contrato, el presente Anexo y sus Ap&eacute;ndices tendr&aacute;n una vigencia de 3 (tres) a&ntilde;os contados a partir de la fecha de su firma, y se prorrogar&aacute;n autom&aacute;ticamente por periodos sucesivos de 1 (un) a&ntilde;o, a menos que cualquiera de las Partes notifique por escrito su</p>
<p>&nbsp;</p>
<p>deseo de no prorrogarlos con por lo menos 6 (seis) meses de anticipaci&oacute;n a la fecha de expiraci&oacute;n del plazo inicial de vigencia o de la pr&oacute;rroga vigente, seg&uacute;n sea el caso.</p>
<p>&nbsp;</p>
<p>En ning&uacute;n caso la vigencia de este Anexo ser&aacute; superior a la vigencia del Contrato.</p>
<p>&nbsp;</p>
<p>En prueba de conformidad y enteradas de su contenido y alcance legal, las Partes firman por triplicado el presente Anexo, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de diciembre de 2021.</p>
<p>&nbsp;</p>
<p>ALT&Aacute;N</p>
<h4>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</h4>
<p>&nbsp;</p>
<p>CLIENTE</p>
<h4>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</h4>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Gabriel Cejudo Funes</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Miguel Adri&aacute;n &Aacute;lvarez Manzo</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p>AP&Eacute;NDICE 11.1 ALCANCE T&Eacute;CNICO</p>
<p>MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN</p>
<p>PORCENTUAL FIJO</p>
<p>&nbsp;</p>
<p>El presente documento es el Ap&eacute;ndice 11.1 &ldquo;Alcance T&eacute;cnico MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo; al</p>
<p>que se refiere el Anexo 11 &ldquo;Servicios MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS &nbsp;CON &nbsp;MARGEN &nbsp;PORCENTUAL &nbsp;FIJO&rdquo; &nbsp;del &nbsp;Contrato &nbsp;Marco &nbsp;de</p>
<p>Prestaci&oacute;n de Servicios de Telecomunicaciones (junto con sus Anexos y Ap&eacute;ndices,&nbsp;&nbsp;&nbsp;&nbsp; el &ldquo;<strong>Contrato</strong>&rdquo;) celebrado entre las Partes el 7 de diciembre de 2021. Los t&eacute;rminos con inicial may&uacute;scula que se utilizan en el presente Ap&eacute;ndice tienen el significado que&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; se les atribuye en el Contrato o en el propio Anexo 11 &ldquo;Servicios MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL</p>
<p>FIJO&rdquo; o este Ap&eacute;ndice, seg&uacute;n corresponda. Para la interpretaci&oacute;n del presente Ap&eacute;ndice, las Partes se sujetar&aacute;n a lo estipulado en la Cl&aacute;usula 1.4 del Contrato.</p>
<p>&nbsp;</p>
<h4><u>PRIMERA. Introducci&oacute;n</u></h4>
<p><strong>&nbsp;</strong></p>
<p>El presente Ap&eacute;ndice describe la soluci&oacute;n t&eacute;cnica y funcional del conjunto de servicios que Alt&aacute;n ofrece al Cliente para el Servicio de MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>El Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON</p>
<p>MARGEN PORCENTUAL FIJO es el Servicio de conectividad m&oacute;vil que incluye el servicio de Datos con acceso a internet provisto por Alt&aacute;n o por el Cliente, el servicio de Voz utilizando tecnolog&iacute;as VoLTE y/o mVoIP y el servicio de env&iacute;o y recepci&oacute;n de mensajes cortos. Asimismo, Alt&aacute;n proveer&aacute; la plataforma de Gesti&oacute;n Mayorista conformada por los m&oacute;dulos deadministraci&oacute;n de recursos de numeraci&oacute;n y conciliaci&oacute;n de tr&aacute;fico, entre otros.</p>
<p>&nbsp;</p>
<p>El Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON</p>
<p>MARGEN PORCENTUAL FIJO se clasifica en las siguientes categor&iacute;as:</p>
<p>&nbsp;</p>
<ul>
<li>Servicios de conectividad m&oacute;vil</li>
<li>Servicio de gesti&oacute;n mayorista</li>
<li>Otros Servicios</li>
</ul>
<p>&nbsp;</p>
<h4><u>SEGUNDA. Cobertura del Servicio</u></h4>
<p><strong>&nbsp;</strong></p>
<p>La cobertura del Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO, as&iacute; como las funcionalidades descritas en el presente Ap&eacute;ndice ser&aacute;n aplicables dentro de la Cobertura de la Red Compartida.</p>
<p>&nbsp;</p>
<p>El Cliente podr&aacute; consultar la Cobertura de la Red Compartida seg&uacute;n la herramienta de consulta que Alt&aacute;n pondr&aacute; a su disposici&oacute;n.</p>
<p>&nbsp;</p>
<p>Alt&aacute;n pondr&aacute; a disposici&oacute;n del Cliente el Servicio de Usuario Visitante mediante el cual podr&aacute; ampliar los Servicios en aquellas zonas geogr&aacute;ficas incluidas en las &Aacute;reas de Cobertura del Acuerdo de Usuario Visitante.</p>
<p>&nbsp;</p>
<p>Alt&aacute;n pondr&aacute; a disposici&oacute;n del Cliente el Servicio de Roaming Internacional mediante el cual podr&aacute; ampliar los Servicios en aquellos pa&iacute;ses donde Alt&aacute;n tenga disponible el Servicio de Roaming Internacional bajo los acuerdos que celebre con otros operadores.</p>
<p>&nbsp;</p>
<p>La prestaci&oacute;n de los Servicios de Usuario Visitante y de Roaming Internacional se har&aacute; de acuerdo con las condiciones t&eacute;cnicas espec&iacute;ficas de los proveedores de estos Servicios.</p>
<p>&nbsp;</p>
<h4><u>TERCERA. Responsabilidad de las Partes</u></h4>
<p><strong>&nbsp;</strong></p>
<p>En la siguiente tabla se incluye un resumen de los elementos y responsabilidades funcionales involucrados en la prestaci&oacute;n del Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO, as&iacute; como la</p>
<p>responsabilidad de cada Parte asociada a cada uno de ellos: Para el servicio de conectividad m&oacute;vil, las responsabilidades son:</p>
<table class="table">
<tbody>
<tr>
<td width="314">
<p><strong>Infraestructura de red</strong></p>
</td>
<td width="162">
<p><strong>Alt&aacute;n</strong></p>
</td>
<td width="100">
<p><strong>Cliente</strong></p>
</td>
</tr>
<tr>
<td width="314">
<p>eNB</p>
</td>
<td width="162">
<p>&uuml;</p>
</td>
<td width="100">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="314">
<p>MME</p>
</td>
<td width="162">
<p>&uuml;</p>
</td>
<td width="100">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="314">
<p>SGW</p>
</td>
<td width="162">
<p>&uuml;</p>
</td>
<td width="100">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="314">
<p>PGW</p>
</td>
<td width="162">
<p>&uuml;</p>
</td>
<td width="100">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="314">
<p>SBC</p>
</td>
<td width="162">
<p>&uuml;</p>
</td>
<td width="100">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="314">
<p>HSS/HLR</p>
</td>
<td width="162">
<p>&uuml;</p>
</td>
<td width="100">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="314">
<p>PCRF</p>
</td>
<td width="162">
<p>&uuml;</p>
</td>
<td width="100">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="314">
<p>MSC/MGW</p>
</td>
<td width="162">
<p>&uuml;</p>
</td>
<td width="100">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="314">
<p>DRA</p>
</td>
<td width="162">
<p>&uuml;</p>
</td>
<td width="100">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="314">
<p>CORE IMS</p>
</td>
<td width="162">
<p>&uuml;</p>
</td>
<td width="100">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="314">
<p>IP-SM-GW</p>
</td>
<td width="162">
<p>&uuml;</p>
</td>
<td width="100">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="314">
<p>DPI</p>
</td>
<td width="162">
<p>&uuml;</p>
</td>
<td width="100">
<p>&uuml;</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="314">
<p>ACS/TAS/App m&oacute;vil (para VoIP propietario de Alt&aacute;n)</p>
</td>
<td width="162">
<p>&nbsp;</p>
<p>&uuml;</p>
</td>
<td width="100">
<p>&nbsp;</p>
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="314">
<p>DNS Movilidad APNs</p>
</td>
<td width="162">
<p>&uuml;</p>
</td>
<td width="100">
<p>&ucirc;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 1. Infraestructura de red</em></p>
<p><em>&nbsp;</em></p>
<p>Consideraciones de la Tabla 1. Infraestructura de Red en Alt&aacute;n y en Cliente:</p>
<p>&nbsp;</p>
<ul>
<li>Para aquellos elementos donde s&oacute;lo Alt&aacute;n o el Cliente son responsables, debe entenderse que la Parte Responsable implementar&aacute; los elementos de Infraestructura requeridos para el funcionamiento del</li>
<li>Para aquellos elementos donde tanto Alt&aacute;n como el Cliente son responsables, deber&aacute; entenderse que las dos partes podr&aacute;n implementar estos elementos de Infraestructura requeridos para el funcionamiento del Producto, seg&uacute;n acuerdo entre las</li>
<li>Para la interpretaci&oacute;n de la tabla anterior las Partes se sujetar&aacute;n a lo estipulado en el documento Especificaciones Funcionales y de</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="393">
<p><strong>Numeraci&oacute;n</strong></p>
</td>
<td width="80">
<p><strong>Alt&aacute;n</strong></p>
</td>
<td width="78">
<p><strong>Cliente</strong></p>
</td>
</tr>
<tr>
<td width="393">
<p>MNC</p>
</td>
<td width="80">
<p>&uuml;</p>
</td>
<td width="78">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="393">
<p>IMSI</p>
</td>
<td width="80">
<p>&uuml;</p>
</td>
<td width="78">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="393">
<p>MSISDNs/DNs</p>
</td>
<td width="80">
<p>&uuml;</p>
</td>
<td width="78">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="393">
<p>Numeraci&oacute;n Corta</p>
</td>
<td width="80">
<p>&uuml;</p>
</td>
<td width="78">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="393">
<p>IDD/IDO</p>
</td>
<td width="80">
<p>&uuml;</p>
</td>
<td width="78">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="393">
<p>IDA</p>
</td>
<td width="80">
<p>&ucirc;</p>
</td>
<td width="78">
<p>&uuml;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 2. Numeraci&oacute;n</em></p>
<p><em>&nbsp;</em></p>
<table class="table">
<tbody>
<tr>
<td width="393">
<p><strong>Interconexi&oacute;n y Roaming</strong></p>
</td>
<td width="80">
<p><strong>Alt&aacute;n</strong></p>
</td>
<td width="78">
<p><strong>Cliente</strong></p>
</td>
</tr>
<tr>
<td width="393">
<p>Interconexi&oacute;n voz y SMS a Redes Fijas y M&oacute;viles Nacionales</p>
</td>
<td width="80">
<p><em>&nbsp;</em></p>
<p>&uuml;</p>
</td>
<td width="78">
<p><em>&nbsp;</em></p>
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="393">
<p>LDI</p>
</td>
<td width="80">
<p>&uuml;</p>
</td>
<td width="78">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="393">
<p>Roaming Internacional</p>
</td>
<td width="80">
<p>&uuml;</p>
</td>
<td width="78">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="393">
<p>Servicio de Acuerdo de Usuario Visitante</p>
</td>
<td width="80">
<p>&uuml;</p>
</td>
<td width="78">
<p>&ucirc;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 3. Interconexi&oacute;n y Roaming</em></p>
<p><em>&nbsp;</em></p>
<p>Consideraciones de la Tabla 3. Interconexi&oacute;n y Roaming:</p>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n pondr&aacute; a disposici&oacute;n del Cliente el Servicio de Roaming Internacional mediante el cual podr&aacute; ampliar los Servicios en aquellos pa&iacute;ses donde Alt&aacute;n tenga disponible el Servicio de Roaming</li>
<li>Alt&aacute;n pondr&aacute; a disposici&oacute;n del Cliente el Servicio de Larga Distancia Internacional (LDI) mediante el cual los Usuarios Finales del Cliente pueden hacer uso de los acuerdos vigentes que tiene Alt&aacute;n con Operadores Internacionales para la terminaci&oacute;n y recepci&oacute;n de llamadas de Voz y mensajes de texto con destino u originadas en redes m&oacute;viles o fijas fuera de M&eacute;xico.</li>
<li>En caso de que el Cliente requiera usar su propio servicio de Larga Distancia Internacional (LDI) y/o de Roaming Internacional, se manejar&aacute; mediante un acuerdo comercial espec&iacute;fico, y/o un acuerdo de proyecto especial, ambos sujetos a viabilidad t&eacute;cnica, donde se definan las responsabilidades y alcance de las Partes en la soluci&oacute;n.</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="393">
<p><strong>Acceso a internet</strong></p>
</td>
<td width="80">
<p><strong>Alt&aacute;n</strong></p>
</td>
<td width="78">
<p><strong>Cliente</strong></p>
</td>
</tr>
<tr>
<td width="393">
<p>Direcciones IP P&uacute;blicas</p>
</td>
<td width="80">
<p>&uuml;</p>
</td>
<td width="78">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="393">
<p>CG-NAT/Firewall</p>
</td>
<td width="80">
<p>&uuml;</p>
</td>
<td width="78">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="393">
<p>DNS Internet</p>
</td>
<td width="80">
<p>&uuml;</p>
</td>
<td width="78">
<p>&ucirc;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 4. Acceso a Internet</em></p>
<p><em>&nbsp;</em></p>
<p>Consideraciones de la Tabla 4. Acceso a Internet:</p>
<p>&nbsp;</p>
<ul>
<li>Si la salida a Internet es de Alt&aacute;n, Alt&aacute;n ser&aacute; el responsable de disponer los elementos mencionados en la tabla anterior y la cl&aacute;usula cuarta de este documento; en caso contrario, se manejar&aacute; mediante un acuerdo comercial espec&iacute;fico, y/o un acuerdo de proyecto especial, ambos sujetos a viabilidad t&eacute;cnica, donde se definan las responsabilidades del Cliente y alcance de las Partes en la soluci&oacute;n.</li>
<li>Para la interpretaci&oacute;n de la tabla anterior las Partes se sujetar&aacute;n a lo estipulado en el documento Especificaciones Funcionales y de</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="397">
<p><strong>Otros</strong></p>
</td>
<td width="82">
<p><strong>Alt&aacute;n</strong></p>
</td>
<td width="81">
<p><strong>Cliente</strong></p>
</td>
</tr>
<tr>
<td width="397">
<p>Proveedores comprobados de SIMs</p>
</td>
<td width="82">
<p>&uuml;</p>
</td>
<td width="81">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="397">
<p>Listado de Terminales comprobados</p>
</td>
<td width="82">
<p>&uuml;</p>
</td>
<td width="81">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="397">
<p>Adquisici&oacute;n de SIMs</p>
</td>
<td width="82">
<p>&ucirc;</p>
</td>
<td width="81">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="397">
<p>Adquisici&oacute;n de Equipos Terminales</p>
</td>
<td width="82">
<p>&ucirc;</p>
</td>
<td width="81">
<p>&uuml;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 5. Adquisici&oacute;n de equipos y SIMs</em></p>
<p>&nbsp;</p>
<p><em>&nbsp;</em></p>
<table class="table">
<tbody>
<tr>
<td width="397">
<p><strong>Servicios regulatorios</strong></p>
</td>
<td width="82">
<p><strong>Alt&aacute;n</strong></p>
</td>
<td width="81">
<p><strong>Cliente</strong></p>
</td>
</tr>
<tr>
<td width="397">
<p>Intervenci&oacute;n Legal</p>
</td>
<td width="82">
<p>&uuml;</p>
</td>
<td width="81">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="397">
<p>Geolocalizaci&oacute;n</p>
</td>
<td width="82">
<p>&uuml;</p>
</td>
<td width="81">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="397">
<p>Datos Conservados</p>
</td>
<td width="82">
<p>&uuml;</p>
</td>
<td width="81">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="397">
<p>Llamadas de emergencia</p>
</td>
<td width="82">
<p>&uuml;</p>
</td>
<td width="81">
<p>&uuml;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 6. Servicios Regulatorios</em></p>
<p><em>&nbsp;</em></p>
<p>Alcance de la Coadyuvancia de Alt&aacute;n a los Servicios Regulatorios mencionados en la Tabla 6. Servicios Regulatorios:</p>
<p>&nbsp;</p>
<ul>
<li>El Cliente ser&aacute; el responsable ante los requisitos de la Autoridad Designada para Servicios Regulatorios.</li>
<li>Los servicios regulatorios mencionados ser&aacute;n entregados a Cliente solo bajo demanda de una Autoridad Designada, previa gesti&oacute;n de la misma por el</li>
<li>Alt&aacute;n ofrecer&aacute; coadyuvancia al Cliente a trav&eacute;s de Soporte T&eacute;cnico para que pueda cumplir con dichos</li>
<li>Para la interpretaci&oacute;n de la tabla anterior las Partes se sujetar&aacute;n a lo estipulado en el documento Especificaciones Funcionales y de</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="393">
<p><strong>Servicios de valor agregado</strong></p>
</td>
<td width="96">
<p><strong>Alt&aacute;n</strong></p>
</td>
<td width="78">
<p><strong>Cliente</strong></p>
</td>
</tr>
<tr>
<td width="393">
<p>SMSC</p>
</td>
<td width="96">
<p>&uuml;</p>
</td>
<td width="78">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="393">
<p>IVR</p>
</td>
<td width="96">
<p>&uuml;</p>
</td>
<td width="78">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="393">
<p>Buz&oacute;n de voz</p>
</td>
<td width="96">
<p>&uuml;</p>
</td>
<td width="78">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="393">
<p>Acuerdos y SMS para servicio de contenidos.</p>
</td>
<td width="96">
<p>&ucirc;</p>
</td>
<td width="78">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="393">
<p>Acuerdos comerciales con Agregador/Cadenas de recargas</p>
</td>
<td width="96">
<p>&nbsp;</p>
<p>&ucirc;</p>
</td>
<td width="78">
<p>&nbsp;</p>
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="393">
<p>OTA</p>
</td>
<td width="96">
<p>&uuml;</p>
</td>
<td width="78">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="393">
<p>MMS</p>
</td>
<td width="96">
<p>&ucirc;</p>
</td>
<td width="78">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="393">
<p>Device manager</p>
</td>
<td width="96">
<p>&ucirc;</p>
</td>
<td width="78">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="393">
<p>Configuraci&oacute;n Mayorista de Ofertas Comerciales</p>
</td>
<td width="96">
<p>&uuml;</p>
</td>
<td width="78">
<p>&uuml;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 7. Servicios de Valor Agregado</em></p>
<p><em>&nbsp;</em></p>
<p>Alcance de Servicios de valor agregado mencionados en la Tabla 7:</p>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n ser&aacute; responsable de la Configuraci&oacute;n Mayorista de Ofertas Comerciales cuando el Cliente seleccione la Estructura Tarifaria Productos Empaquetados, seg&uacute;n se define en el Ap&eacute;ndice 11.2 &ldquo;T&Eacute;RMINOS COMERCIALES Y ESTRUCTURAS TARIFARIAS MOVILIDAD SIM ALT&Aacute;N: MARGEN PORCENTUAL FIJO SOBRE PRECIO DE REFERENCIA&rdquo;. La solicitud por parte del Cliente para configurar m&aacute;s de sesenta (60) ofertas, ser&aacute; evaluada t&eacute;cnicamente y sujeta a un acuerdo comercial entre las partes. Se considerar&aacute; una (1) oferta cada una de las l&iacute;neas del Formato de Configuraci&oacute;n de</li>
<li>El Cliente podr&aacute; solicitar a Alt&aacute;n la Configuraci&oacute;n Mayorista de un (1) mecanismo de control predefinido por Alt&aacute;n en el Formato de Configuraci&oacute;n de Ofertas cuando haya contratado Estructuras Tarifarias a Granel para cualquiera de los servicios que lo</li>
<li>Alt&aacute;n, mediante solicitud del Cliente y bajo previa factibilidad t&eacute;cnica y sujeto a un acuerdo comercial entre las partes, podr&aacute; realizar la Configuraci&oacute;n Mayorista de mecanismos de control adicionales cuando el Cliente haya contratado Estructuras Tarifarias a Granel para cualquiera de los servicios que lo</li>
<li>El Cliente ser&aacute; el responsable de la Configuraci&oacute;n de Oferta Comercial Minorista como parte de su Gesti&oacute;n del Usuario</li>
</ul>
<p>&nbsp;</p>
<p>Para el servicio de gesti&oacute;n mayorista, las responsabilidades son las siguientes:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="403">
<p><strong>Servicios de gesti&oacute;n mayorista</strong></p>
</td>
<td width="95">
<p><strong>Alt&aacute;n</strong></p>
</td>
<td width="77">
<p><strong>Cliente</strong></p>
</td>
</tr>
<tr>
<td width="403">
<p>Interfaz de Portabilidad</p>
</td>
<td width="95">
<p>&uuml;</p>
</td>
<td width="77">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="403">
<p>Interfaz de Administraci&oacute;n de recursos de numeraci&oacute;n</p>
</td>
<td width="95">
<p>&uuml;</p>
</td>
<td width="77">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="403">
<p>Interfaz de Gesti&oacute;n Estados de Suscripci&oacute;n de los Usuarios Finales</p>
</td>
<td width="95">
<p>&nbsp;</p>
<p>&uuml;</p>
</td>
<td width="77">
<p>&nbsp;</p>
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="403">
<p>Conciliaci&oacute;n Mayorista</p>
</td>
<td width="95">
<p>&uuml;</p>
</td>
<td width="77">
<p>&ucirc;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 8. Servicios de Gesti&oacute;n Mayorista</em></p>
<p><em>&nbsp;</em></p>
<p>El Cliente deber&aacute; asumir toda responsabilidad frente a sus Usuarios Finales, debiendo responder por todas las actividades de gesti&oacute;n de cada Usuario Final que a continuaci&oacute;n se mencionan de manera enunciativa, pero no limitativa:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="393">
<p><strong>Gesti&oacute;n Usuario Final</strong></p>
</td>
<td width="96">
<p><strong>Alt&aacute;n</strong></p>
</td>
<td width="78">
<p><strong>Cliente</strong></p>
</td>
</tr>
<tr>
<td width="393">
<p>Gesti&oacute;n Ciclo de Vida Usuario Final (Alta / Modificaci&oacute;n / Baja)</p>
</td>
<td width="96">
<p>&ucirc;</p>
</td>
<td width="78">
<p>&nbsp;</p>
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="393">
<p>Medios de Cobro y Recargas</p>
</td>
<td width="96">
<p>&ucirc;</p>
</td>
<td width="78">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="393">
<p>Oferta Comercial y Servicios a Usuario Final</p>
</td>
<td width="96">
<p>&ucirc;</p>
</td>
<td width="78">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="393">
<p>Configuraci&oacute;n de Oferta Comercial Minorista</p>
</td>
<td width="96">
<p>&ucirc;</p>
</td>
<td width="78">
<p>&uuml;</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="393">
<p>Gesti&oacute;n de Incidencias Usuario Final y Call Center</p>
</td>
<td width="96">
<p>&ucirc;</p>
</td>
<td width="78">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="393">
<p>Plataformas de:</p>
<p>&nbsp;</p>
<p>*&nbsp; Pasarela de Pagos</p>
<p>&nbsp;</p>
<p>*&nbsp; PAC (timbrado de facturas),</p>
<p>&nbsp;</p>
<p>*&nbsp; ERP (Finanzas)</p>
<p>*&nbsp; Log&iacute;stico, Marketing, Campa&ntilde;as, eShop/eCareWeb / Mobile APP&hellip;.</p>
</td>
<td width="96">
<p>&nbsp;</p>
<p>&ucirc;</p>
</td>
<td width="78">
<p>&nbsp;</p>
<p>&uuml;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 9. Gest&iacute;on de Usuario Final</em></p>
<p><em>&nbsp;</em></p>
<h4><u>CUARTA. Servicios de Conectividad M&oacute;vil</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Los Servicios de conectividad m&oacute;vil pueden incluir: el Servicio de Datos, los Servicios de Voz v&iacute;a VoLTE o v&iacute;a VoIP propietaria Alt&aacute;n (en adelante &ldquo;<strong>mVoIP</strong>&rdquo;) y Mensajer&iacute;a SMS, seg&uacute;n se indica en esta Cl&aacute;usula Cuarta. Alt&aacute;n proporciona al Cliente estos Servicios en la Cobertura de la Red Compartida, en igualdad de condiciones y sobre bases de no discriminaci&oacute;n respecto al resto de sus</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Servicios de Datos.</li>
</ul>
<p>&nbsp;</p>
<p>Alt&aacute;n prestar&aacute; al Cliente el Servicio de Datos por el que los Usuarios Finales del Cliente podr&aacute;n transmitir y recibir paquetes de datos no conmutados desde un terminal m&oacute;vil comprobado en la Cobertura de la Red Compartida.</p>
<p>&nbsp;</p>
<p>Para el establecimiento de una conexi&oacute;n de datos se debe abrir un contexto de datos. Transcurrido un tiempo de 10 (diez) minutos sin que se produzca transmisi&oacute;n de Datos, Alt&aacute;n proceder&aacute; a cerrar el contexto de datos.</p>
<p>&nbsp;</p>
<ul>
<li>Acceso a internet Alt&aacute;n.</li>
</ul>
<p>&nbsp;</p>
<p>Alt&aacute;n ofrecer&aacute; el acceso a internet al Cliente utilizando sus plataformas para entregar el tr&aacute;fico de datos a la red p&uacute;blica de internet. El Servicio incluye el servicio de DNS, Firewall y CG-NAT (Network Address Translation) que permite la traducci&oacute;n de IPs privadas a IPs p&uacute;blicas en internet, as&iacute; como el ISP para que el Cliente cuente con navegaci&oacute;n en internet.</p>
<p>&nbsp;</p>
<ul>
<li>Acceso a internet Cliente</li>
</ul>
<p>&nbsp;</p>
<p>En caso que Cliente quiera disponer de su propio acceso a Internet, se manejar&aacute; mediante un acuerdo comercial espec&iacute;fico, y/o un acuerdo de proyecto especial, ambos sujetos a viabilidad t&eacute;cnica, donde se definan las responsabilidades del Cliente y alcance de las Partes en la soluci&oacute;n.</p>
<p>&nbsp;</p>
<ul>
<li>Tr&aacute;fico de datos para uso en aplicaciones espec&iacute;ficas del Cliente</li>
</ul>
<p>&nbsp;</p>
<p>En el caso que Cliente requiera la identificaci&oacute;n y cuantificaci&oacute;n de un tr&aacute;fico de datos asociado al uso de aplicaciones y/o URLs espec&iacute;ficas del Cliente, su posible implementaci&oacute;n se manejar&aacute; mediante un acuerdo de proyecto especial, sujeto a viabilidad t&eacute;cnica y comercial, donde se definir&aacute;n las responsabilidades del Cliente y alcance de las Partes en la soluci&oacute;n. Los ajustes comerciales que se generen como resultado positivo de esta evaluaci&oacute;n, ser&aacute;n indicados en el Ap&eacute;ndice 11.3 &ldquo;Tarifas MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;.</p>
<p>&nbsp;</p>
<p>El an&aacute;lisis de factibilidad t&eacute;cnica realizado por Alt&aacute;n requiere de informaci&oacute;n que deber&aacute; ser proporcionada por el Cliente para este prop&oacute;sito, que de forma enunciativa mas no limitativa, incluye la siguiente:</p>
<p>&nbsp;</p>
<ul>
<li>El listado de todas las aplicaciones y/o URLs espec&iacute;ficas del Cliente que quieren ser identificadas y cuantificadas.</li>
<li>El listado de todos los destinos de tr&aacute;fico (direcciones IP, URLs con sus dominios y subdominios) que est&eacute;n asociados con el correcto funcionamiento de las aplicaciones en cuesti&oacute;n, incluyendo aquellos destinos dirigidos a plataformas de terceros o de otras plataformas propias del Cliente, incluyendo sus respectivas direcciones IP, URLs con sus dominios y</li>
</ul>
<p>En el caso de que el Cliente requiera la actualizaci&oacute;n o modificaci&oacute;n de las aplicaciones y/o URLs previamente configuradas, se manejar&aacute; mediante un nuevo acuerdo de proyecto especial, sujeto a viabilidad t&eacute;cnica y comercial, conservando las responsabilidades de las Partes en la soluci&oacute;n enunciadas en el presente numeral.</p>
<p>&nbsp;</p>
<p>Es posible que antes de finalizar el an&aacute;lisis de factibilidad t&eacute;cnica, Alt&aacute;n requiera que el Cliente realice pruebas de an&aacute;lisis de tr&aacute;fico de sus aplicaciones y/o URLs espec&iacute;ficas, por lo cual el Cliente se compromete a disponer los recursos t&eacute;cnicos y humanos que Alt&aacute;n le indique para poder llevar a cabo estas pruebas, y a compartir los resultados de las mismas con Alt&aacute;n.</p>
<p>&nbsp;</p>
<p>En cualquier caso, Alt&aacute;n solo configurar&aacute; aquellas aplicaciones y/o URLs especificadas por el Cliente, incluyendo las direcciones IP y URLs con sus dominios y subdominios que se soliciten configurar por el Cliente en su solicitud. Alt&aacute;n no ser&aacute; responsable por el malfuncionamiento de las aplicaciones y/o URLs especificadas por el Cliente, sea porque las mismas no est&eacute;n operando correctamente, o porque la informaci&oacute;n entregada por el Cliente para la configuraci&oacute;n de la identificaci&oacute;n y cuantificaci&oacute;n del tr&aacute;fico de dichas aplicaciones y/o URLs no este completo o no sea suficiente para su correcto funcionamiento.</p>
<p>&nbsp;</p>
<ul>
<li>Servicios de Voz.</li>
</ul>
<p>&nbsp;</p>
<p>Alt&aacute;n pondr&aacute; a disposici&oacute;n del Cliente el Servicio de conectividad m&oacute;vil de Voz, por el que los Usuarios Finales del Cliente podr&aacute;n realizar y recibir llamadas de Voz desde un terminal m&oacute;vil comprobado en la Cobertura de la Red Compartida.</p>
<p>&nbsp;</p>
<p>Todo el tr&aacute;fico de Voz generado por los Usuarios Finales del Cliente ser&aacute; terminado o recibido por Alt&aacute;n utilizando sus rutas de interconexi&oacute;n propias con los diferentes</p>
<p>&nbsp;</p>
<p>operadores de M&eacute;xico, as&iacute; como con operadores nacionales e internacionales para las llamadas LDI.</p>
<p>&nbsp;</p>
<p>En relaci&oacute;n con lo anterior, se pueden presentar los siguientes escenarios de servicio: Voz Saliente y Voz Entrante.</p>
<p>&nbsp;</p>
<p>Dependiendo del tipo de terminal del Usuario Final, el Servicio de Voz se podr&aacute; prestar mediante tecnolog&iacute;a mVoIP o VoLTE.</p>
<p>&nbsp;</p>
<ul>
<li>Voz Saliente.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li><strong>Voz entre m&oacute;viles ambos en la Red Compartida: </strong>El Usuario Final del Cliente genera una llamada de Voz (VoLTE/mVoIP) desde su terminal en Cobertura de la Red Compartida con destino a otro Usuario Final de un Cliente de la Red Compartida, la cual ser&aacute; procesada y entregada por Alt&aacute;n mediante VoLTE o</li>
<li><strong>Voz hacia destino nacional: </strong>El Usuario Final del Cliente genera una llamada de voz desde su terminal en Cobertura de la Red Compartida, cuyo destino est&aacute; en otro Operador Nacional (m&oacute;vil o fijo), la cual ser&aacute; entregada por Alt&aacute;n. El Cliente podr&aacute; utilizar los acuerdos de interconexi&oacute;n de Alt&aacute;n para la terminaci&oacute;n de llamadas a nivel nacional (PSTN).</li>
<li><strong>Voz hacia destino internacional: </strong>El Usuario Final del Cliente genera una llamada de voz desde su terminal en Cobertura de la Red Compartida, cuyo destino est&aacute; en otro Operador Internacional (m&oacute;vil o fijo), la cual ser&aacute; entregada por Alt&aacute;n utilizando sus acuerdos de Interconexi&oacute;n para la terminaci&oacute;n de llamadas a nivel Internacional LDI.
<ul>
<li>Voz entrante.</li>
</ul>
</li>
</ul>
<p>&nbsp;</p>
<ul>
<li><strong>Voz entrante en la Red Compartida: </strong>El Usuario Final del Cliente en Cobertura de Alt&aacute;n recibe una llamada de Voz (VoLTE/mVoIP) de otros usuarios finales dentro de la Red</li>
<li><strong>Voz entrante nacional (Operador diferente a Alt&aacute;n): </strong>En el caso de llamadas de Voz terminadas en la Red Compartida, Alt&aacute;n recibe la llamada desde la PSTN/PLMN debido a que contiene su IDD y tendr&aacute; que analizar y procesar esta llamada antes de entregarla al Usuario Final con VoLTE o</li>
<li><strong>Voz entrante internacional: </strong>En el caso de las llamadas Voz terminadas en la Red Compartida, Alt&aacute;n recibe la llamada desde sus propias interconexiones internacionales (LDI) y tendr&aacute; que analizar y procesar esta llamada antes de entregarla al Usuario Final mediante VoLTE o</li>
</ul>
<p>&nbsp;</p>
<p>Cada escenario de Voz es excluyente e independiente de los otros escenarios mencionados en este apartado.</p>
<p>&nbsp;</p>
<p>Esta modalidad de Servicio de Voz se podr&aacute; prestar con terminales que soportan VoLTE, y se ofrece utilizando directamente las funcionalidades VoLTE del equipo terminal. Es necesario que el terminal sea comprobado por Alt&aacute;n para soportar este Servicio.</p>
<p>&nbsp;</p>
<p>La llamada VoLTE se origina directamente en la terminal del Usuario Final del Cliente y se recibe por la plataforma IMS de Alt&aacute;n donde se realiza el procesamiento de la llamada, incluyendo la codificaci&oacute;n de la voz en caso de que la llamada tenga que direccionarse a un destino que no soporte VoLTE.</p>
<p>&nbsp;</p>
<p>El Servicio de VoLTE utiliza el acceso LTE, HSS, EPC y la plataforma Core IMS/AS VoLTE de Alt&aacute;n, as&iacute; como tambi&eacute;n PSTN y LDI.</p>
<p>&nbsp;</p>
<ul>
<li>mVoIP:</li>
</ul>
<p>&nbsp;</p>
<p>El servicio de voz de mVoIP de Alt&aacute;n permite la operaci&oacute;n de terminales que, teniendo la funcionalidad LTE, no soportan el servicio VoLTE. Este Servicio funciona mediante la instalaci&oacute;n de una aplicaci&oacute;n m&oacute;vil mVoIP facilitada por Alt&aacute;n en la terminal del Usuario Final del Cliente.</p>
<p>&nbsp;</p>
<p>Para poder utilizar este Servicio es necesario que el Usuario Final del Cliente cuente con un equipo terminal comprobado por Alt&aacute;n para mVoIP, as&iacute; como la aplicaci&oacute;n mVoIP instalada en la terminal del Usuario Final.</p>
<p>&nbsp;</p>
<p>Las llamadas realizadas con el mVoIP propietario de Alt&aacute;n tienen priorizaci&oacute;n en la red superior a cualquier otro tr&aacute;fico de datos y ligeramente inferior al tr&aacute;fico de VoLTE. El servicio mVoIP inicialmente s&oacute;lo estar&aacute; disponible en cobertura Alt&aacute;n.</p>
<p>&nbsp;</p>
<p>El Servicio de mVoIP utiliza el acceso LTE, EPC y la plataforma Core IMS/AS mVoIP de Alt&aacute;n, as&iacute; como tambi&eacute;n PSTN y LDI.</p>
<p>&nbsp;</p>
<ul>
<li>Funcionalidades del Servicio VoLTE/mVoIP:</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Locuciones de Red.</li>
</ul>
<p>&nbsp;</p>
<p>La plataforma IMS de Alt&aacute;n proporciona las locuciones para las llamadas de Voz que se producen cuando la llamada no ha podido ser terminada, incluyendo los tonos est&aacute;ndar y avisos de notificaci&oacute;n como Usuario Final fuera del &aacute;rea de Cobertura de la Red Compartida, terminal ocupada y aviso de marcaci&oacute;n incorrecta, entre otros.</p>
<p>&nbsp;</p>
<ul>
<li>Numeraci&oacute;n</li>
</ul>
<p>&nbsp;</p>
<p>Con el prop&oacute;sito de facilitar la gesti&oacute;n de los Usuarios Finales del Cliente, Alt&aacute;n pondr&aacute; a disposici&oacute;n de este la facilidad de usar numeraci&oacute;n corta, de forma que puedan ser usada por los Usuarios Finales del Cliente para servicios de consulta de buz&oacute;n de voz, IVR o servicio de atenci&oacute;n al Usuario Final (Call Center). Las marcaciones cortas podr&aacute;n ser de entre 3 y 5 d&iacute;gitos. El Cliente solicitar&aacute; la numeraci&oacute;n corta que necesite y Alt&aacute;n proceder&aacute; a asignarla en funci&oacute;n de su disponibilidad.</p>
<p>&nbsp;</p>
<ul>
<li>Normalizaci&oacute;n de D&iacute;gitos y An&aacute;lisis Num&eacute;rico.</li>
</ul>
<p>&nbsp;</p>
<p>La plataforma IMS detecta la secuencia de numeraci&oacute;n marcada por el usuario y procede a formatearla de manera correcta dependiendo del destino de la llamada.</p>
<p>&nbsp;</p>
<p>Esta funci&oacute;n permite gestionar correctamente la llamada, siempre y cuando la numeraci&oacute;n marcada por el Usuario contenga un m&iacute;nimo de 7 y 8 d&iacute;gitos para llamadas a fijos y con m&iacute;nimo 10 d&iacute;gitos para llamadas a m&oacute;viles. La normalizaci&oacute;n de d&iacute;gitos s&oacute;lo aplica para llamadas a n&uacute;meros fijos y m&oacute;viles nacionales.</p>
<p>&nbsp;</p>
<p>De igual manera, a partir del 3 de agosto de 2019, el Usuario Final deber&aacute; llamar a 10 d&iacute;gitos para destinos locales y nacionales; y marcar a 12 d&iacute;gitos para destinos internacionales. En caso de realizar llamadas con menor cantidad o mayor cantidad de d&iacute;gitos a los mencionados, la llamada no ser&aacute; establecida.</p>
<p>&nbsp;</p>
<ul>
<li>Negociaci&oacute;n de C&oacute;dec</li>
</ul>
<p>&nbsp;</p>
<p>La plataforma IMS de Alt&aacute;n permite tambi&eacute;n realizar el cambio de CODEC de la llamada de Voz para adaptarlo al requerido por el destino de esta, esto permite la interconexi&oacute;n de llamadas de Voz entre diferentes redes y diferentes tipos de terminales con CODECs distintos. La plataforma de ALT&Aacute;N actualmente soporta los siguientes CODECs: G.711 (Ley A), G.729AB, G.722, AMR-NB y AMR-WB.</p>
<p>&nbsp;</p>
<ul>
<li>Servicios Suplementarios de</li>
</ul>
<p>&nbsp;</p>
<p>Alt&aacute;n podr&aacute; suministrar al Cliente los siguientes Servicios suplementarios de Voz:</p>
<p>&nbsp;</p>
<ul>
<li><strong>Desv&iacute;o de Llamada (Call Forwarding)</strong>: El desv&iacute;o de llamadas permite transferir las llamadas entrantes, hacia cualquier otro n&uacute;mero telef&oacute;nico m&oacute;vil o fijo previamente configurado. El desv&iacute;o de llamada se puede presentar de distintas formas:</li>
</ul>
<p>&nbsp;</p>
<ul>
<li><em>Desv&iacute;o Incondicional</em>, permite al Usuario Final desviar o direccionar todas las llamadas entrantes hacia otro n&uacute;mero.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li><strong>Multi-conferencia Tripartita</strong>: Permite establecer una comunicaci&oacute;n entre tres Usuarios Finales simult&aacute;neamente. El tr&aacute;fico generado por los Usuarios Finales ser&aacute; facturado de forma independiente, de forma que cada comunicaci&oacute;n con otro Usuario Final ser&aacute; facturada como una llamada</li>
<li><strong>Llamada en Espera (Call Waiting): </strong>Permite que al Usuario Final contestar una nueva llamada entrante, mientras mantiene en espera una llamada previamente El Usuario Final escucha un tono indic&aacute;ndole que existe otra llamada entrante y cuenta con un tiempo acotado por el operador para responder la llamada, si as&iacute; lo desea, antes de ser cancelada.</li>
<li><strong>Identificaci&oacute;n de Llamada (Caller ID): </strong>Permite identificar, en la terminal del Usuario Final, el n&uacute;mero telef&oacute;nico de la llamada entrante y tambi&eacute;n conocer las llamadas recibidas que no fueron</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Servicios de Mensajer&iacute;a</li>
</ul>
<p>&nbsp;</p>
<p>Alt&aacute;n soportar&aacute; que el Cliente ofrezca el Servicio de Mensajer&iacute;a SMS (en lo sucesivo &ldquo;<strong>SMS</strong>&rdquo;), por el que los Usuarios Finales del Cliente podr&aacute;n realizar y recibir mensajes de texto cortos de un m&aacute;ximo de 160 caracteres desde un terminal m&oacute;vil comprobado en la Cobertura de la Red Compartida.</p>
<p>&nbsp;</p>
<p>Todo el tr&aacute;fico de SMS generado por los Usuarios Finales del Cliente ser&aacute; terminado o recibido por Alt&aacute;n utilizando sus rutas de interconexi&oacute;n propias con los diferentes operadores m&oacute;viles de M&eacute;xico, as&iacute; como con operadores internacionales para los SMS internacionales.</p>
<p>&nbsp;</p>
<p>Alt&aacute;n solo proveer&aacute; los medios de acceso v&iacute;a LTE y elementos de Core para que el Cliente pueda entregar y recibir mensajes cortos de sus usuarios finales.</p>
<p>&nbsp;</p>
<p>Alt&aacute;n se reserva el derecho de bloquear cualquier mensajer&iacute;a corta con origen y destino diferente a los acordados en el presente Ap&eacute;ndice, el Anexo 11 &ldquo;Servicios MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN</p>
<p>PORCENTUAL FIJO&rdquo; y cualquiera de sus Ap&eacute;ndices, tales como los env&iacute;os de mensajes cortos desde aplicaciones hacia usuarios finales en destinos nacionales o internacionales.</p>
<p>&nbsp;</p>
<p>En relaci&oacute;n con lo anterior, se pueden presentar los siguientes escenarios de servicio:</p>
<p>&nbsp;</p>
<h4><u>SMS Saliente:</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong>SMS entre Usuarios Finales del Cliente: </strong>El Usuario Final del Cliente env&iacute;a un SMS desde su terminal con destino a otro Usuario Final del Cliente o bien una plataforma de servicios (ej. consulta de saldo) en Cobertura de Red</li>
<li><strong>SMS Nacional: </strong>El Usuario Final del Cliente env&iacute;a un SMS desde su terminal, cuyo destino est&aacute; en otro Operador M&oacute;vil Nacional y es entregado por Alt&aacute;n en sus acuerdos de interconexi&oacute;n</li>
<li><strong>SMS Internacional: </strong>El Usuario Final del Cliente env&iacute;a un SMS desde su terminal, cuyo destino est&aacute; en otro Operador Internacional y es entregado por Alt&aacute;n en sus acuerdos de interconexi&oacute;n Internacionales para</li>
<li><strong>SMS Contenido: </strong>El Usuario Final del Cliente podr&aacute; subscribirse a servicios de contenidos de SMS a trav&eacute;s de marcaci&oacute;n de numeraci&oacute;n corta (las marcaciones podr&aacute;n ser entre 3 y 5 d&iacute;gitos). El Cliente ser&aacute; el responsable de la firma del acuerdo con los distintos Proveedores de Servicios de Contenidos, siendo Alt&aacute;n &uacute;nicamente responsable del enrutamiento de los mensajes por la integraci&oacute;n con la plataforma del Proveedor del Servicio de Contenidos es responsabilidad del Cliente por lo tanto para este Servicio es necesario que el Cliente provea su propio</li>
</ul>
<p>&nbsp;</p>
<h4><u>SMS Entrante:</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong>SMS entrante en la Red Compartida: </strong>El Usuario Final del Cliente en Cobertura de Alt&aacute;n recibe un SMS de otro Usuario Final desde cualquier origen fijo o m&oacute;vil, nacional o</li>
<li><strong>SMS entrante nacional: </strong>En el caso de SMS terminadas en la Red Compartida, Alt&aacute;n recibe el SMS desde la Interconexi&oacute;n SMS y tendr&aacute; que analizar y procesar este SMS antes de entregarlo al Usuario</li>
<li><strong>SMS entrante internacional: </strong>En el caso de las SMS terminados en la Red Compartida, Alt&aacute;n recibe el SMS desde sus propias interconexiones internacionales y tendr&aacute; que analizar y procesar este SMS antes de entregarlo al Usuario Final</li>
</ul>
<p>&nbsp;</p>
<p>Teniendo en cuenta la Regulaci&oacute;n Mexicana relacionada a los servicios de SMS, particularmente los relacionados con normas Anti-Spam y Anti-Fraude, el Cliente confirma y acepta que cumplir&aacute; con los lineamientos de prevenci&oacute;n y correcci&oacute;n de este tipo de eventos que est&aacute;n definidos por la mencionada Regulaci&oacute;n. Adicionalmente, el Cliente confirma que acepta y que cumplir&aacute; con los lineamientos a nivel de interconexi&oacute;n SMS definidos por los operadores con los cuales Alt&aacute;n tiene acuerdo para este servicio, y que le ser&aacute;n notificados por Alt&aacute;n.</p>
<p>&nbsp;</p>
<p>De acuerdo a esta Regulaci&oacute;n, se consideran pr&aacute;cticas prohibidas, en forma no limitativa, las siguientes:</p>
<p>&nbsp;</p>
<ul>
<li>Spamming: Env&iacute;o por parte de un mismo Usuario Origen de 10 mensajes Spam con el mismo contenido en el transcurso de 1 (un)</li>
<li>Flooding: Env&iacute;o de Mensajes Cortos, cuyo fin sea el saturar o disminuir las funciones de cualquier elemento de la Red de la Parte Receptora de los mismos. Para tales efectos, se establecen los siguientes par&aacute;metros en la consideraci&oacute;n del flooding:</li>
</ul>
<p>o El env&iacute;o por parte de un mismo Usuario Origen de 10 (diez) Mensajes Cortos dirigidos al mismo destino en el transcurso de un minuto.</p>
<p>o El env&iacute;o por parte de un mismo Usuario Origen de m&aacute;s de 100 (cien) Mensajes Cortos en el transcurso de un minuto.</p>
<ul>
<li>Que se detecte que la Fuerza de Ventas o Proveedores de Contenidos de una de las Partes env&iacute;e Mensajes Spam, a los Usuarios Destino de la otra</li>
<li>Que se detecte que la Fuerza de Ventas de una de las Partes env&iacute;e a los Usuarios Destino de la otra Parte, cualquier tipo de Mensaje Corto que sugiera la contrataci&oacute;n de los servicios de telecomunicaciones provistos por otra compa&ntilde;&iacute;a celular, as&iacute; como la venta de equipos terminales de cualquier naturaleza, sus accesorios o, cualquier otro servicio o bien que comercialice la Parte</li>
<li>Que los Proveedores de Contenidos de la Parte Remitente env&iacute;en a los Usuarios Destino de la Parte Receptora, Mensajes Cortos que contengan prefijos o c&oacute;digos que puedan ser interpretados por el Equipo Terminal del Usuario Destino como im&aacute;genes, tonos o</li>
<li>Manipular, falsear o insertar informaci&oacute;n en alguno de los campos de los Mensajes Cortos intercambiados a trav&eacute;s del protocolo</li>
<li>Realizar exploraciones en la arquitectura de cualesquiera de los elementos involucrados en la conexi&oacute;n de la otra Parte, con el fin de buscar y/o explotar fallas en la</li>
<li>Enviar cualquier tipo de mensaje que afecte la configuraci&oacute;n/programaci&oacute;n del Equipo Terminal del Usuario</li>
<li>Enviar cualquier tipo de mensaje que pueda afectar, menoscabar o restringir la operaci&oacute;n del Equipo Terminal del Usuario Destino (C&oacute;digo Malicioso).</li>
<li>Enviar mensajes diferentes a los contemplados en los contratos SIEMC (SERVICIO DE INTERCAMBIO ELECTR&Oacute;NICO DE MENSAJES CORTOS) que tiene Alt&aacute;n.</li>
<li>Revelar o comprometer el contenido de los Mensajes Cortos enviados por los Usuarios Origen de la Parte Remitente, siempre y cuando no sea a solicitud expresa de autoridad</li>
<li>El env&iacute;o de Mensajes Cortos originados de manera individual o masiva, por o en servidores, computadoras, sistemas, aplicaciones, servidores externos a la</li>
</ul>
<p>&nbsp;</p>
<p>arquitectura acordada entre las Partes o cualquier otro instrumento, equipo terminal o equipo distinto a un Equipo Terminal.</p>
<p>&nbsp;</p>
<h4>4.5&nbsp; Servicio de Acuerdo de Usuario Visitante.</h4>
<p><strong>&nbsp;</strong></p>
<p>El servicio de Acuerdo de Usuario visitante permite a los Usuarios Finales del Cliente la realizaci&oacute;n y recepci&oacute;n de llamadas de Voz, env&iacute;o y recepci&oacute;n de SMS y Navegaci&oacute;n de Datos en las &Aacute;reas de Cobertura de Acuerdo de Usuario Visitante.</p>
<p>&nbsp;</p>
<p>La llamada de Voz/Datos en el Servicio de Acuerdo de Usuario Visitante se cursar&aacute; seg&uacute;n la tecnolog&iacute;a de acceso Voz/Datos disponible por el Roaming Partner de Alt&aacute;n en las &Aacute;reas de Cobertura de Acuerdo de Usuario Visitante.</p>
<p>&nbsp;</p>
<p>Las Partes acordar&aacute;n las medidas de gesti&oacute;n para el uso adecuado del Servicio de Usuario Visitante, las cuales quedar&aacute;n estipuladas en el documento Especificaciones Funcionales y de Servicio.</p>
<p>&nbsp;</p>
<ul>
<li>Tr&aacute;fico Internacional prestado por parte de Alt&aacute;n.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Terminaci&oacute;n y Recepci&oacute;n de Voz</li>
</ul>
<p>&nbsp;</p>
<p>Es el Servicio prestado por parte de Alt&aacute;n, por medio del cual los Usuarios Finales del Cliente pueden hacer uso de los acuerdos vigentes que tiene Alt&aacute;n con Operadores Internacionales para la terminaci&oacute;n y recepci&oacute;n de llamadas de Voz con destino u originadas en redes m&oacute;viles o fijas fuera de M&eacute;xico.</p>
<p>&nbsp;</p>
<ul>
<li>Terminaci&oacute;n y Recepci&oacute;n de SMS</li>
</ul>
<p>&nbsp;</p>
<p>Es el Servicio prestado por parte de Alt&aacute;n, por medio del cual los Usuarios Finales del Cliente pueden hacer uso de los acuerdos vigentes que tiene Alt&aacute;n con Operadores Internacionales para la terminaci&oacute;n y recepci&oacute;n de SMS con destino u originados en redes m&oacute;viles o fijas fuera de M&eacute;xico.</p>
<p>&nbsp;</p>
<ul>
<li>Larga Distancia Internacional por parte del Cliente</li>
</ul>
<p>&nbsp;</p>
<p>En caso de que el Cliente requiera usar su propio servicio de Larga Distancia Internacional, se manejar&aacute; mediante un acuerdo comercial espec&iacute;fico, sujeto a viabilidad t&eacute;cnica, donde se definan las responsabilidades y alcance de las Partes en la soluci&oacute;n.</p>
<p>&nbsp;</p>
<h4>4.7&nbsp; Roaming Internacional.</h4>
<p><strong>&nbsp;</strong></p>
<p>El Servicio de Roaming Internacional permite a los Usuarios Finales del Cliente la realizaci&oacute;n y recepci&oacute;n de llamadas de Voz, env&iacute;o y recepci&oacute;n de SMS y Servicios de Datos en las redes de Operadores Internacionales con los Alt&aacute;n tenga disponible el Servicio de Roaming Internacional.</p>
<p>&nbsp;</p>
<p>El Servicio de Roaming Internacional estar&aacute; disponible en aquellas redes de Operadores Internacionales que tengan implementado Camel Fase 2.</p>
<p>&nbsp;</p>
<p>Alt&aacute;n informar&aacute; al Cliente de los pa&iacute;ses y operadores con los que est&aacute; disponible el Servicio de Roaming Internacional, as&iacute; como de las Tecnolog&iacute;as de Acceso de Roaming Internacional Disponibles en cada una de ellas.</p>
<p>&nbsp;</p>
<p>Para poder tener habilitado servicio en Roaming Internacional el usuario deber&aacute; haber sido activado en territorio nacional y contar con consumos previos en la Red Alt&aacute;n. No se permitir&aacute; el uso permanente de los servicios Alt&aacute;n en Roaming internacional.</p>
<p>&nbsp;</p>
<p>Las Partes acordar&aacute;n las medidas de gesti&oacute;n para el uso adecuado del Servicio de Roaming Internacional, las cuales quedar&aacute;n estipuladas en el documento Especificaciones Funcionales y de Servicio.</p>
<p>&nbsp;</p>
<p>Para el correcto funcionamiento del Servicio, el Cliente deber&aacute; garantizar la implementaci&oacute;n del perfil el&eacute;ctrico que permita el funcionamiento del Servicio de Roaming Internacional de Alt&aacute;n con su proveedor de tarjetas SIM, seg&uacute;n las definiciones y procedimientos dispuestos por Alt&aacute;n.</p>
<p>&nbsp;</p>
<p>Los servicios de Voz/Datos/SMS en el Servicio de Roaming Internacional se cursar&aacute;n seg&uacute;n la tecnolog&iacute;a de acceso de Voz/Datos/SMS disponible del Operador que preste el Servicio de Roaming Internacional y las capacidades del Equipo Terminal del Usuario Final.</p>
<p>&nbsp;</p>
<h4>4.8&nbsp; Llamadas de emergencia.</h4>
<p><strong>&nbsp;</strong></p>
<p>Las Partes acuerdan que para que los Usuarios Finales realicen llamadas de emergencia se usar&aacute; la mejor Red disponible, que t&eacute;cnicamente sea posible utilizar, en el entendido de que los operadores de esa red deber&aacute;n cumplir con lo que establezca el IFT para tal efecto.</p>
<p>&nbsp;</p>
<h4>4.9&nbsp; Gesti&oacute;n del Enlace de Integraci&oacute;n.</h4>
<p><strong>&nbsp;</strong></p>
<p>Alt&aacute;n pone a disposici&oacute;n del Cliente los siguientes medios de integraci&oacute;n: VPNs o enlaces dedicados, de acuerdo a sus proyecciones de tr&aacute;fico.</p>
<p>&nbsp;</p>
<p>Alt&aacute;n pone a disposici&oacute;n del Cliente 2 (dos) nodos terminantes para implementar las VPNs o enlaces de integraci&oacute;n entre la red del Cliente y la Red Compartida. Durante la Puesta en Marcha, el Cliente deber&aacute; conectarse a los 2 (dos) nodos que se tienen disponibles en Alt&aacute;n, a saber:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="288">
<p><strong>TULTITL&Aacute;N, ESTADO DE M&Eacute;XICO</strong></p>
</td>
<td width="288">
<p><strong>APODACA, NUEVO LEON</strong></p>
</td>
</tr>
<tr>
<td width="288">
<p>Av. Benito Ju&aacute;rez 20, Col. San Mateo Cuautepec, Macrocentro Tultitl&aacute;n, Tultitl&aacute;n, Estado de M&eacute;xico, CP 54948</p>
</td>
<td width="288">
<p>Carretera Miguel Alem&aacute;n KM 17.5, Parque Industrial Kalos, Interior Arist&oacute;teles 119, nave 6, Apodaca, Nuevo</p>
<p>Le&oacute;n, CP 66600</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>Los enlaces de integraci&oacute;n se determinar&aacute; en funci&oacute;n de las proyecciones de tr&aacute;fico y Usuarios Finales entregadas por el Cliente a Alt&aacute;n. En caso de que el Cliente pretenda modificar el enlace de integraci&oacute;n, deber&aacute; notific&aacute;rselo a Alt&aacute;n.</p>
<p>&nbsp;</p>
<p>A trav&eacute;s de estos enlaces, y en funci&oacute;n del alcance de los servicios provistos por Alt&aacute;n se podr&iacute;a intercambiar la siguiente informaci&oacute;n:</p>
<p>&nbsp;</p>
<ul>
<li>Tr&aacute;fico de datos (GTPv1 y GTPv2)</li>
<li>Tr&aacute;fico de DNS</li>
<li>Transferencia de CDR (sFTP)</li>
</ul>
<p>&nbsp;</p>
<h4>4.9.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Evoluci&oacute;n del Enlace de Integraci&oacute;n.</h4>
<p><strong>&nbsp;</strong></p>
<p>El enlace de integraci&oacute;n vendr&aacute; marcado por las fases de despliegue en las que se encuentre:</p>
<p>&nbsp;</p>
<p>Etapa Inicial: El Nodo de Alt&aacute;n, su geolocalizaci&oacute;n y el ancho de banda del enlace ser&aacute; establecido en funci&oacute;n al tr&aacute;fico proyectado y mencionado en el Ap&eacute;ndice 11.6 &ldquo;Proyecciones MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS</p>
<p>CON MARGEN PORCENTUAL FIJO&rdquo; correspondiente al Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Fase de crecimiento: una vez que se alcance un 80% de ocupaci&oacute;n de los enlaces de fase inicial, medido en hora pico, se abrir&aacute; otro nodo de integraci&oacute;n donde se usar&aacute;n pol&iacute;ticas de distribuci&oacute;n de carga entre los dos nodos.</p>
<p>&nbsp;</p>
<p>Fase de maduraci&oacute;n: conforme vaya aumentando la cobertura y capilaridad de la Red Compartida, Alt&aacute;n podr&aacute; solicitar a Cliente la apertura de nuevos nodos de integraci&oacute;n, as&iacute; como aumentar la capacidad de los ya existentes. A tal efecto, ambas Partes acuerdan incrementar la capacidad de integraci&oacute;n en cuanto un enlace de conexi&oacute;n llegue a un 80% de ocupaci&oacute;n, medido en hora pico.</p>
<p>&nbsp;</p>
<h4><u>QUINTA. Servicios de Gesti&oacute;n Mayorista</u></h4>
<p><strong>&nbsp;</strong></p>
<p>Los Servicios de Gesti&oacute;n Mayorista son aquellos Servicios que Alt&aacute;n ofrece al Cliente a trav&eacute;s de Interfaces disponibles para que este sea capaz de habilitar y gestionar los Servicios de Conectividad del Servicio de MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>La Plataforma de Gesti&oacute;n Mayorista de Alt&aacute;n est&aacute; conformada por los siguientes m&oacute;dulos principales:</p>
<p>&nbsp;</p>
<ul>
<li>Administraci&oacute;n de Recursos de Numeraci&oacute;n</li>
<li>Conciliaci&oacute;n de Tr&aacute;fico</li>
<li>Gesti&oacute;n de Portabilidad</li>
<li>Gesti&oacute;n Estados de Suscripci&oacute;n de los Usuarios Finales</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Administraci&oacute;n de Recursos de Numeraci&oacute;n</li>
</ul>
<p>&nbsp;</p>
<p>El Cliente solicitar&aacute; a Alt&aacute;n, a trav&eacute;s del formulario "Solicitud de Provisi&oacute;n de nuevas SIMs", la generaci&oacute;n de un <em>input file </em>para que el fabricante de SIMs comprobado por Alt&aacute;n con el que el Cliente tiene un acuerdo comercial proceda a su fabricaci&oacute;n. Una vez que</p>
<p>&nbsp;</p>
<p>el fabricante ha generado las SIMs, le facilitar&aacute; a Alt&aacute;n los archivos OUT y CPS para que los cargue en su plataforma HSS.</p>
<p>&nbsp;</p>
<p>La modalidad para la provisi&oacute;n de SIMs es Numeradas: En el momento de creaci&oacute;n de la SIM por parte del fabricante se le asigna la dupla IMSI y MSISDN definitiva.</p>
<p>&nbsp;</p>
<ul>
<li>Conciliaci&oacute;n de Tr&aacute;fico.</li>
</ul>
<p>&nbsp;</p>
<p>Alt&aacute;n proporcionar&aacute; los CDR y EDR que muestran el consumo de Voz, mensajes y datos para que el Cliente los recupere a trav&eacute;s de una conexi&oacute;n sFTP y pueda hacer el procesamiento de estos y utilizarlos como conciliaci&oacute;n de tr&aacute;fico entre ambas redes. Adem&aacute;s, pueden ser utilizados por el Cliente para generar al Usuario Final su pre-factura final.</p>
<p>&nbsp;</p>
<p>Para el Servicio de Datos se recolectar&aacute;n los registros de cada una de las sesiones de datos y su consumo. Este tipo de registros son llamados CDR y se colectan en el EPC, por lo que tambi&eacute;n estar&aacute;n disponibles para que el Cliente los recolecte y procese para la realizaci&oacute;n de la conciliaci&oacute;n mayorista.</p>
<p>&nbsp;</p>
<p>Para el cobro en l&iacute;nea del Servicio de Datos se utilizar&aacute; el OCS de Alt&aacute;n para que se haga el cobro en tiempo real.</p>
<p>&nbsp;</p>
<p>Para el servicio de Voz (VoLTE y mVoIP), todas las llamadas que se originan/terminan en el Core de IMS Alt&aacute;n generan un registro (CDR) con los datos primordiales que muestran los detalles de la llamada. Estos CDR se generan dentro del Core IMS y otros elementos de la Red Compartida y posteriormente se almacenan en un directorio compartido para que se utilicen en la conciliaci&oacute;n mayorista.</p>
<p>&nbsp;</p>
<p>Para el cobro en l&iacute;nea del Servicio de Voz se utilizar&aacute; el OCS de Alt&aacute;n para que se haga el cobro en tiempo real.</p>
<p>&nbsp;</p>
<ul>
<li>Mensajes Cortos (SMS)</li>
</ul>
<p>&nbsp;</p>
<p>Para el servicio de SMS, todos los eventos que se originan/terminan en las plataformas de Alt&aacute;n generan un registro (CDR) con los datos primordiales que muestran los detalles de los eventos. Estos CDR se generan dentro del Core IMS y otros elementos de la Red Compartida y posteriormente se almacenan en un directorio compartido para que se utilicen en la conciliaci&oacute;n mayorista.</p>
<p>&nbsp;</p>
<p>Para el cobro en l&iacute;nea del Servicio de SMS se utilizar&aacute; el OCS de Alt&aacute;n para que se haga el cobro en tiempo real.</p>
<p>&nbsp;</p>
<ul>
<li>Gesti&oacute;n de la</li>
</ul>
<p>&nbsp;</p>
<p>Alt&aacute;n pondr&aacute; a disposici&oacute;n del Cliente una herramienta que permita ejecutar y/o notificar la portabilidad de suscripciones de Usuarios Finales siguiendo en todo momento todos los preceptos legales aplicables para tal efecto.</p>
<p>&nbsp;</p>
<p>El Cliente deber&aacute; hacer la integraci&oacute;n directamente con el ABD y soportar todos los escenarios de Portabilidades en sus sistemas. En este escenario el Cliente debe notificar los cambios de portabilidades de Usuarios Finales a Alt&aacute;n a trav&eacute;s de la herramienta proporcionada por Alt&aacute;n.</p>
<p>&nbsp;</p>
<p>De forma alternativa, y en caso que el Cliente no logre tener disponible la integraci&oacute;n con el ABD, Alt&aacute;n dispondr&aacute; el sistema de gesti&oacute;n de portabilidades para el Cliente mediante dicha herramienta, la cual est&aacute;r&aacute; sincronizada con el ABD y realizar&aacute; la provisi&oacute;n hacia el Core de Alt&aacute;n. En este escenario, el Cliente ser&aacute; responsable por la ejecuci&oacute;n de la portabilidad.</p>
<p>&nbsp;</p>
<p>A continuaci&oacute;n se presentan las funcionalidades de portabilidad que deber&aacute;n ser ejecutadas por el Cliente:</p>
<p>&nbsp;</p>
<ul>
<li>Portabilidad</li>
</ul>
<p>&nbsp;</p>
<p>Este proceso est&aacute; alineado con las Reglas de Portabilidad Num&eacute;rica emitidas por el IFT y le permite al Cliente completar todo el proceso de portabilidad, incluyendo, entre otros, los pasos para el alta y aprovisionamiento del Usuario Final entrante. Tambi&eacute;n le permite al Cliente gestionar el alta del recurso MSISDN portado desde otro operador y darle seguimiento a su ciclo de vida.</p>
<p>&nbsp;</p>
<ul>
<li>Portabilidad</li>
</ul>
<p>&nbsp;</p>
<p>Este proceso le permite al Cliente procesar las solicitudes salientes de portabilidad y completar el procesamiento de solicitud saliente. Permite tambi&eacute;n completar el borrado del aprovisionamiento del Usuario Final y dar de baja el recurso de MSISDN portado hacia otro operador y dar seguimiento a su ciclo de vida.</p>
<p>&nbsp;</p>
<p>Con esta funci&oacute;n un Usuario Final que fue portado de forma irregular o que determin&oacute; regresar a su red de origen es r&aacute;pidamente reinstalado con sus mismos par&aacute;metros originales sin necesidad de procesar una nueva alta.</p>
<p>&nbsp;</p>
<ul>
<li>Cancelaci&oacute;n.</li>
</ul>
<p>&nbsp;</p>
<p>En caso de que el Usuario Final decida cancelar su solicitud de portabilidad o el operador de destino no logre procesar la solicitud, el Cliente podr&aacute; ejecutar la funci&oacute;n de cancelaci&oacute;n tanto a nivel del sistema de Alt&aacute;n como en el ABD correspondiente.</p>
<p>&nbsp;</p>
<ul>
<li>Devoluci&oacute;n Entrante</li>
</ul>
<p>&nbsp;</p>
<p>Este proceso permite dar seguimiento a los recursos de MSISDN que han sido portados hacia otros operadores. En caso de que el Usuario Final cancele su servicio despu&eacute;s de haber sido portado, el sistema de portabilidad de Alt&aacute;n permite que se realice la funci&oacute;n</p>
<p>&nbsp;</p>
<p>de retorno de este recurso y lo reinstala al inventario disponible de acuerdo con las pol&iacute;ticas de uso.</p>
<p>&nbsp;</p>
<ul>
<li>Gesti&oacute;n Estados de Suscripci&oacute;n de los Usuarios Finales</li>
</ul>
<p>&nbsp;</p>
<p>El Cliente podr&aacute; solicitar a Alt&aacute;n el cambio de los estados del Ciclo de Vida del Usuario Final. Para el producto MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO, Alt&aacute;n define los siguientes estados como se describe a continuaci&oacute;n:</p>
<p>&nbsp;</p>
<ul>
<li><strong>Estado Pre-Activo</strong>. Estado en el cual nacen las SIM Cards. En este estado, el Usuario Final no podr&aacute; emitir y/o recibir Datos, Voz y/o</li>
<li><strong>Estado Activo. </strong>Un Usuario Final ser&aacute; considerado como Activo desde el momento en el que el Cliente lo declare v&iacute;a API, o se registre y genere tr&aacute;fico en la</li>
<li><strong>Estado Suspendido Tr&aacute;fico Saliente. </strong>Los Usuarios Finales que pasan a este estado podr&aacute;n recibir llamadas y SMS en Territorio Nacional seg&uacute;n lo servicios contratados, por lo tanto, los costos implicados seguir&aacute;n aplic&aacute;ndose seg&uacute;n sea el caso (incluyendo Usuario Visitante cuando aplique). Para el Estado Suspendido Tr&aacute;fico Saliente no se podr&aacute;: i) Generar Llamadas Salientes; ii) Generar SMS Salientes; iii) Recibir o emitir</li>
<li><strong>Estado Suspendido Tr&aacute;fico Saliente y Entrante. </strong>Los Usuarios Finales que pasan al Estado Suspendido Tr&aacute;fico Saliente y Entrante no podr&aacute;n hacer uso de ninguno de los servicios</li>
<li><strong>Estado Pre-Desactivo. </strong>En este estado, los Usuarios Finales no podr&aacute;n hacer uso de ninguno de los servicios contratados. El Usuario Final permanecer&aacute; en este estado 365 d&iacute;as naturales hasta pasar al estado Desactivo, por lo cual durante este per&iacute;odo puede ser En caso de Reactivaci&oacute;n, el Usuario Final conservar&aacute; las condiciones de Ciclo Individual y los servicios contratados.</li>
<li><strong>Estado </strong>Un Usuario Final puede pasar a Desactivo de dos formas: i) Una vez que permanece 365 d&iacute;as naturales en estado Pre-Desactivo; o ii) De forma inmediata y desde cualquier estado, a trav&eacute;s de la notificaci&oacute;n del Cliente. En este estado, la SIM Card no tiene asociada ning&uacute;n Producto. Desaparece la informaci&oacute;n de la suscripci&oacute;n del Usuario Final para ALT&Aacute;N, y se recicla la numeraci&oacute;n.</li>
</ul>
<p>&nbsp;</p>
<h4><u>SEXTA. Otros Servicios</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Numeraci&oacute;n.</li>
</ul>
<p>&nbsp;</p>
<p>Los recursos de numeraci&oacute;n de IMSIs y MSISDN ser&aacute;n provistos por Alt&aacute;n al Cliente.</p>
<p>&nbsp;</p>
<p>El Cliente solicitara a Alt&aacute;n un rango de IMSIs en base a sus proyecciones de tr&aacute;fico. Alt&aacute;n facilitar&aacute; un rango de IMSIs que permitan al Cliente cubrir con la demanda de Usuarios Finales incluida en el Ap&eacute;ndice 11.6 &ldquo;Proyecciones MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;.</p>
<p>&nbsp;</p>
<p>Los MSISDNs ser&aacute;n provistos por Alt&aacute;n. Alt&aacute;n asignar&aacute; los recursos de numeraci&oacute;n de MSISDNs por cada ASL (zona de marcaci&oacute;n) necesarios para que el Cliente pueda cumplir con su desarrollo comercial.</p>
<p>&nbsp;</p>
<p>El Cliente reconoce la importancia del cumplimiento de las previsiones de tr&aacute;fico y Usuarios Finales previamente mencionadas para facilitar la gesti&oacute;n y dimensionamiento, por parte de Alt&aacute;n, de sus sistemas, redes y gesti&oacute;n de la numeraci&oacute;n asignada (DNs) por ASL.</p>
<p>&nbsp;</p>
<p>El Cliente ser&aacute; responsable de la comercializaci&oacute;n y compra de las tarjetas SIMs. A tal efecto, Alt&aacute;n facilitar&aacute; el listado de fabricantes de tarjetas SIMs comprobados por Alt&aacute;n con las especificaciones t&eacute;cnicas de perfil el&eacute;ctrico y applets necesarios para su correcto funcionamiento en la Red Compartida.</p>
<p>&nbsp;</p>
<p>En caso de que el Cliente decida utilizar otro fabricante, Alt&aacute;n colaborar&aacute; con el Cliente para que este pueda dar la informaci&oacute;n suficiente y necesaria al fabricante de tarjetas SIMs para que estas SIMs puedan tener una correcta operaci&oacute;n en la Red Compartida y las caracter&iacute;sticas t&eacute;cnicas del presente Ap&eacute;ndice. Alt&aacute;n comprobar&aacute; al nuevo fabricante seleccionado por el Cliente, conforme a las pol&iacute;ticas y criterios aplicables de Alt&aacute;n y las Leyes Aplicables.</p>
<p>&nbsp;</p>
<p>El Cliente ser&aacute; responsable de la comercializaci&oacute;n y compra de los dispositivos m&oacute;viles LTE. Alt&aacute;n publicar&aacute; en su portal de internet y con una periodicidad mensual, un listado con los modelos y versiones de dispositivos m&oacute;viles LTE que funcionan en la banda 28 del 3GPP (700 MHz), que se encuentran comprobados por Alt&aacute;n para su correcta operaci&oacute;n en la Red Compartida y que en el caso de soportar servicios de Voz y SMS interoperan con las tecnolog&iacute;as de voz VoLTE y/o mVoIP de Alt&aacute;n. La lista antes mencionada es gestionada por Alt&aacute;n y podr&aacute; variar de tiempo en tiempo.</p>
<p>&nbsp;</p>
<p>El Cliente, &uacute;nicamente podr&aacute; utilizar y comercializar los modelos y versiones de dispositivos m&oacute;viles LTE incluidos en la citada lista y que sean relacionados expresamente a este Producto, asegurando la correcta configuraci&oacute;n de los mismos seg&uacute;n sea indicado por Alt&aacute;n, y que son los &uacute;nicos que se pueden utilizar para el Producto MOVILIDAD; salvo aquellos casos en los que expresamente no se encuentre prohibido en los Productos se&ntilde;alados en el Ap&eacute;ndice 11.3 &ldquo;Tarifas MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;. De</p>
<p>no cumplirse las condiciones aqu&iacute; enlistadas, Alt&aacute;n se reserva el derecho a tomar las medidas que considere pertinentes para todos los usuarios del Cliente en Estado Activo con la finalidad de prevenir riesgos operativos y t&eacute;cnicos en la red.</p>
<p>&nbsp;</p>
<ul>
<li>Comprobaci&oacute;n de otros dispositivos m&oacute;viles LTE</li>
</ul>
<p>&nbsp;</p>
<p>En caso de que el Cliente desee utilizar dispositivos m&oacute;viles LTE para sus Usuarios Finales que no han sido comprobados por Alt&aacute;n, Alt&aacute;n colaborar&aacute; con el Cliente para que este pueda dar la informaci&oacute;n suficiente y necesaria al fabricante de dispositivos m&oacute;viles LTE para que estos dispositivos m&oacute;viles LTE puedan tener una correcta operaci&oacute;n en la Red Compartida bajo las caracter&iacute;sticas t&eacute;cnicas del presente Ap&eacute;ndice. Alt&aacute;n comprobar&aacute; los modelos seleccionados por el Cliente, conforme a las pol&iacute;ticas y criterios</p>
<p>&nbsp;</p>
<p>aplicables de Alt&aacute;n y las Leyes Aplicables y una vez se cumplan los criterios se incorporar&aacute;n a la lista de dispositivos m&oacute;viles LTE comprobados.</p>
<p>&nbsp;</p>
<p>Las caracter&iacute;sticas m&iacute;nimas de los dispositivos m&oacute;viles LTE para ser comprobados por Alt&aacute;n son las siguientes:</p>
<p>&nbsp;</p>
<ul>
<li>Operar en la banda 28 del 3GPP (banda 700 MHZ)</li>
<li>Release 9 3GPP y/o superiores</li>
<li>Que soporte y tenga habilitado VoLTE, en caso de que soporten y requiran el uso de servicios de Voz y</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Dispositivos m&oacute;viles LTE no comprobados</li>
</ul>
<p>&nbsp;</p>
<p>Para el caso en que los Usuarios Finales del Cliente proporcionen su propio dispositivo m&oacute;vil LTE, es responsabilidad del Cliente verificar el dispositivo m&oacute;vil LTE con el que sus Usuarios Finales utilizan el servicio, con la finalidad de garantizar que sus Usuarios Finales utilizan dispositivos m&oacute;viles LTE que:</p>
<p>&nbsp;</p>
<ul>
<li>Funcionan en la banda 28 del 3GPP (700 MHz)</li>
<li>Soportan alguna de las soluciones de voz dispuestas por Alt&aacute;n, en caso de que soporten y requieran el uso de servicios de Voz y SMS:
<ul>
<li>VoLTE (Equipos comprobados por Alt&aacute;n)</li>
<li>mVoIP (Equipos no comprobados)</li>
</ul>
</li>
<li>Se encuentren configurados seg&uacute;n las indicaciones de Alt&aacute;n.</li>
</ul>
<p>&nbsp;</p>
<p>Los dispositivos m&oacute;viles LTE dispuestos por los Usuarios Finales del Cliente que cumplan con estas caracter&iacute;sticas son los &uacute;nicos que el Cliente puede permitir utilizar para que el Producto MOVILIDAD sea prestado adecuadamente.</p>
<p>&nbsp;</p>
<ul>
<li>Combinaci&oacute;n de dispositivos y Producto</li>
</ul>
<p>&nbsp;</p>
<p>Si el Cliente quiere ofrecer servicios de Datos, Voz y SMS, &uacute;nicamente podr&aacute; utilizar y comercializar los modelos y dispositivos m&oacute;viles LTE incluidos en el numeral 6.3 o que cumplan con las condiciones indicados en el numeral 6.3.2 que soporten conjuntamente los servicios de Datos, Voz y SMS, y que est&eacute;n relacionados expresamente a los Productos se&ntilde;alados en el Ap&eacute;ndice 11.3 &ldquo;Tarifas MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;.</p>
<p>&nbsp;</p>
<p>Si el Cliente quiere ofrecer exclusivamente el servicio de Datos, s&oacute;lo podr&aacute; utilizar y comercializar los modelos y dispositivos m&oacute;viles LTE incluidos en el numeral 6.3 o que cumplan con las condiciones indicados en el numeral 6.3.2 que soporten &uacute;nicamente el servicio de Datos, y que est&eacute;n relacionados expresamente a los Productos se&ntilde;alados en el Ap&eacute;ndice 11.3 &ldquo;Tarifas MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;.</p>
<p>&nbsp;</p>
<p>De no cumplirse las condiciones aqu&iacute; enlistadas, Alt&aacute;n se reserva el derecho a tomar las medidas que considere pertinentes para todos los usuarios del Cliente en Estado Activo con la finalidad de asegurar el uso correcto de la combinaci&oacute;n de los Productos y dispositivos sobre la red.</p>
<p>&nbsp;</p>
<p>El EIR forma parte de la Infraestructura de ALT&Aacute;N, siendo Alt&aacute;n responsable de actualizar la base de datos EIR con aquellos c&oacute;digos IMEI de las terminales que se han dado de alta como perdidas o robadas.</p>
<p>&nbsp;</p>
<p>Para el Servicio de MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS</p>
<p>EMPAQUETADOS CON MARGEN PORCENTUAL FIJO, Alt&aacute;n es responsable de cumplir con la Ley Federal de Telecomunicaciones y Radiodifusi&oacute;n en lo referente al bloqueo e intercambio de las listas de equipos reportados por los Usuarios Finales como extraviados o robados y que no puedan ser utilizados con ning&uacute;n otro Operador M&oacute;vil en M&eacute;xico.</p>
<p>&nbsp;</p>
<p>El Cliente deber&aacute; notificar estas situaciones diariamente a Alt&aacute;n, por los mecanismos establecidos para tales efectos.</p>
<p>&nbsp;</p>
<ul>
<li>Intervenci&oacute;n Legal.</li>
</ul>
<p>&nbsp;</p>
<p>Alt&aacute;n y el Cliente colaborar&aacute;n para la interceptaci&oacute;n e intervenci&oacute;n de las comunicaciones, &uacute;nicamente en caso de que sean requeridos, mediante una orden debidamente fundada conforme a las Leyes Aplicables y motivada, por alguna Autoridad Gubernamental competente.</p>
<p>&nbsp;</p>
<p>Alt&aacute;n facilitar&aacute; al Cliente una herramienta de consulta de Cobertura de la Red Compartida, as&iacute; como de las &Aacute;reas de Cobertura del Acuerdo de Usuario Visitante.</p>
<p>&nbsp;</p>
<p>En prueba de conformidad y enteradas de su contenido y alcance legal, las Partes firman por triplicado el presente Ap&eacute;ndice, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de diciembre de 2021.</p>
<p>&nbsp;</p>
<p>ALT&Aacute;N</p>
<h4>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</h4>
<p>&nbsp;</p>
<p>CLIENTE</p>
<h4>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</h4>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Gabriel Cejudo Funes</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Miguel Adri&aacute;n &Aacute;lvarez Manzo</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p>AP&Eacute;NDICE 11.2</p>
<p>T&Eacute;RMINOS COMERCIALES Y ESTRUCTURAS TARIFARIAS MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN</p>
<p>PORCENTUAL FIJO</p>
<p>&nbsp;</p>
<p>El presente documento es el Ap&eacute;ndice 11.2 &ldquo;T&eacute;rminos Comerciales y Estructuras Tarifarias MOVILIDAD&nbsp; &nbsp;SIM&nbsp; &nbsp;ALT&Aacute;N:&nbsp; &nbsp;GRANEL&nbsp; &nbsp;Y&nbsp; &nbsp;PRODUCTOS&nbsp; &nbsp;EMPAQUETADOS&nbsp; &nbsp;CON&nbsp; &nbsp;MARGEN</p>
<p>PORCENTUAL FIJO&rdquo; al que se refiere el Anexo 11 &ldquo;Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS&nbsp; EMPAQUETADOS&nbsp; CON MARGEN&nbsp; PORCENTUAL&nbsp; FIJO&rdquo;&nbsp; del Contrato Marco de</p>
<p>Prestaci&oacute;n de Servicios de Telecomunicaciones (junto con sus Anexos y&nbsp; Ap&eacute;ndices,&nbsp; el&nbsp; &ldquo;Contrato&rdquo;) celebrado entre las Partes el 7 de diciembre de 2021. Los t&eacute;rminos con inicial may&uacute;scula que se utilizan en el presente Ap&eacute;ndice tienen el significado que se les atribuye en el Contrato o en el propio Anexo 11 &ldquo;Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo; o este Ap&eacute;ndice, seg&uacute;n corresponda. Para la interpretaci&oacute;n del presente Ap&eacute;ndice, las Partes se sujetar&aacute;n a lo estipulado en&nbsp; la&nbsp; cl&aacute;usula 1.4 del Contrato.</p>

<h4><u>PRIMERA. Objeto y consideraciones generales</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>ETal prirfaersieansteacAoprd&eacute;andoicse etinetnre cAoltm&aacute;no yobejel tColieesnttaebpleacrear llaosptr&eacute;ersmtaincio&oacute;sncdoeml eSrecriavliecisoydleascEonsetrcutcivtuidrads m&oacute;vil de la Red Compartida para el Servicio de MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Consideraciones Generales:</li>
</ul>
<p>&nbsp;</p>
<ol start="11">
<li>Todas las Tarifas de los Servicios mencionados en el presente Ap&eacute;ndice, as&iacute; como sus vigencias y las unidades de medida estar&aacute;n expresadas en el Ap&eacute;ndice 11.3 &ldquo;Tarifas MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>La facturaci&oacute;n del Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO se realizar&aacute; de acuerdo con lo descrito en el Anexo 1 &ldquo;Facturaci&oacute;n y Garant&iacute;as&rdquo;.</li>
</ol>
<p>&nbsp;</p>
<ol start="11">
<li>La prestaci&oacute;n del Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO es para un uso homog&eacute;neo del mismo y con las reglas generales de priorizaci&oacute;n, en el &aacute;rea de Cobertura de la Red Compartida conforme a las previsiones de tr&aacute;fico mencionadas en el Ap&eacute;ndice 11.6 &ldquo;Proyecciones MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;.</li>
</ol>
<p>&nbsp;</p>
<ol start="14">
<li>De conformidad con lo establecido en la Cl&aacute;usula 14.2 del Contrato, las modificaciones sustanciales a este Ap&eacute;ndice deber&aacute;n ser aprobadas por el IFT previo a que sean v&aacute;lidas y surtan efectos.</li>
</ol>
<p>&nbsp;</p>
<ol start="11">
<li>En caso de un incremento en las Tarifas, Alt&aacute;n publicar&aacute; las nuevas Tarifas de acuerdo con lo establecido en el Ap&eacute;ndice 11.3 &ldquo;Tarifas MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;, sin embargo, las nuevas Tarifas ser&aacute;n aplicables y tendr&aacute;n efectos trascurridos 30 (treinta) D&iacute;as desde la fecha en que Alt&aacute;n las publique en la Plataforma Web de</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>El Cliente deber&aacute; elegir entre la Estructura Tarifaria Granel, de conformidad con la cl&aacute;usula segunda de este Ap&eacute;ndice, o la Estructura Tarifaria Productos Empaquetados con Margen Porcentual Fijo, de conformidad con la cl&aacute;usula tercera de este Ap&eacute;ndice. La Estructura Tarifaria elegida ser&aacute; de aplicaci&oacute;n a todos los Usuarios Finales del Cliente, salvo en aquellos casos donde exista un acuerdo mutuo entre las</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>Las siguientes definiciones aplican de forma general al Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li><strong>&ldquo;Ciclo Individual&rdquo; </strong>es la vigencia de los Productos asociados en cada momento a un Usuario Final.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li><strong>&ldquo;Consumo Excedente&rdquo; </strong>es la cantidad de SMS, Voz y/o Datos, a la misma velocidad del Producto, que el Usuario Final consuma dentro del Ciclo Individual una vez superadas las Cuotas del Servicio correspondiente incluidas en el</li>
</ol>
<p>&nbsp;</p>
<ol>
<li><strong>&ldquo;Consumo Excedente a Velocidad Reducida&rdquo;, </strong>es la cantidad de Datos que el Usuario Final podr&aacute; consumir una vez superado el Volumen o la Cuota de Datos definido en el Producto, dentro del Ciclo Individual, y a una Velocidad limitada. Estos consumos no se consideran como Unidad de Tarificaci&oacute;n.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li><strong>&ldquo;Cuota de Datos&rdquo; </strong>es la cantidad de Datos incluida en el Producto que el Usuario Final podr&aacute; utilizar dentro del Ciclo Individual, sin limitaci&oacute;n de la Velocidad de navegaci&oacute;n.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li><strong>&ldquo;Margen Porcentual Fijo&rdquo; </strong>es el tanto por ciento que se descuenta del Precio de Referencia para calcular la Tarifa mayorista de cada</li>
</ol>
<p>&nbsp;</p>
<ol>
<li><strong>&ldquo;Periodo de Comercializaci&oacute;n&rdquo; </strong>es el periodo en el cual los Productos est&aacute;n disponibles para su activaci&oacute;n.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li><strong>&ldquo;Periodo de Validez&rdquo; </strong>se refiere al periodo en el cual se mantienen aplicables las condiciones del Producto comercializado a un Usuario Final, con independencia de que haya vencido el Periodo de Comercializaci&oacute;n.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li><strong>&ldquo;Porcentaje de Consumo Fuera de Huella Alt&aacute;n&rdquo; </strong>es el valor resultante de dividir, el consumo total de cada Producto en Servicio de Usuario Visitante, considerando &uacute;nicamente el Tr&aacute;fico fuera de Cobertura de la Red Compartida, entre su consumo total en territorio</li>
</ol>
<p>&nbsp;</p>
<ol>
<li><strong>&ldquo;Precio de Referencia&rdquo; </strong>es un precio indicativo de referencia de mercado para precios al Usuario Final antes del Impuesto al Valor Agregado (IVA). El Cliente es responsable de definir el precio de venta minorista sin ning&uacute;n condicionante por parte de Alt&aacute;n. El Precio de Referencia s&oacute;lo se utiliza a efectos del c&aacute;lculo de la Tarifa mayorista del Producto.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li><strong>&ldquo;Producto&rdquo; </strong>es una Estructura Tarifaria de Datos, Voz y/o SMS aplicada a un Usuario Final y que, por tanto, tiene un Ciclo Individual</li>
</ol>
<p>&nbsp;</p>
<ol>
<li><strong>"Velocidad"</strong>, es la velocidad m&aacute;xima de navegaci&oacute;n de Datos Downlink del Producto asociado a cada Usuario Final. La velocidad m&aacute;xima s&oacute;lo estar&aacute; limitada en los Productos que expl&iacute;citamente incluyan esta caracter&iacute;stica.</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>El Tr&aacute;fico de Datos, Voz y SMS iniciado o recibido por los Usuarios Finales del Cliente se clasifica, para efectos de tarificaci&oacute;n, en dos tipos en funci&oacute;n de la red que lo curse:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li><strong>&ldquo;Tr&aacute;fico en Cobertura&rdquo;, </strong>es el tr&aacute;fico iniciado o recibido en la Cobertura de la Red Compartida, es decir, aquel tr&aacute;fico de Datos, Voz y SMS que hace uso de los recursos de la red de acceso radio compuesta por los eNB de Alt&aacute;n.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li><strong>&ldquo;Tr&aacute;fico fuera de Cobertura&rdquo;, </strong>es el tr&aacute;fico iniciado o recibido en otras redes distintas de la Red Compartida, tanto nacionales como El Tr&aacute;fico fuera de Cobertura, puede ser a su vez de 2 (dos) tipos:</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Servicio de Usuario Visitante, tanto para Datos, Voz y</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Roaming Internacional, tanto para Datos, Voz y</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>El Tr&aacute;fico de Voz y SMS iniciado o recibido por los Usuarios Finales del Cliente se clasifica, para efectos de tarificaci&oacute;n, en dos tipos en funci&oacute;n del sentido del tr&aacute;fico:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li><strong>&ldquo;Tr&aacute;fico Saliente&rdquo;, </strong>es el tr&aacute;fico que el Usuario Final inicia y que termina dentro o fuera de la Cobertura de la Red Compartida. Las Tarifas de Tr&aacute;fico Saliente no incluyen en ning&uacute;n caso los Servicios de Tarificaci&oacute;n</li>
</ol>
<p>&nbsp;</p>
<ol>
<li><strong>&ldquo;Tr&aacute;fico Entrante&rdquo;, </strong>es el tr&aacute;fico que el Usuario Final recibe dentro o fuera de la Cobertura de la Red Compartida. Este tr&aacute;fico no ser&aacute; facturado a los Clientes cuando se recibe dentro de la Cobertura de la Red Compartida y/o en Servicio de Usuario</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>Adicionalmente, el Tr&aacute;fico Saliente de Voz y SMS, as&iacute; como el Tr&aacute;fico de Datos, tendr&aacute;n la consideraci&oacute;n a efectos de tarificaci&oacute;n de &ldquo;Tr&aacute;fico Nacional&rdquo; cuando utiliza exclusivamente redes nacionales seg&uacute;n se define a continuaci&oacute;n:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li><strong>&ldquo;Tr&aacute;fico de Voz y SMS Nacional&rdquo;, </strong>es el tr&aacute;fico de Voz y SMS que el Usuario Final inicia y que termina en redes nacionales, incluyendo tanto la Cobertura de la Red Compartida, como la cobertura de otras redes nacionales que los Usuarios Finales del Cliente pueden</li>
</ol>
<p>&nbsp;</p>
<p>utilizar al amparo de los acuerdos de Usuario Visitante que Alt&aacute;n tiene suscritos con concesionarios nacionales.</p>
<p>&nbsp;</p>
<ol>
<li><strong>&ldquo;Tr&aacute;fico de Datos Nacional&rdquo;, </strong>es el tr&aacute;fico de Datos que el Usuario Final realiza en redes nacionales, incluyendo tanto la Cobertura de la Red Compartida, como la cobertura de otras redes nacionales que los Usuarios Finales del Cliente pueden utilizar al amparo de los acuerdos de Usuario Visitante que Alt&aacute;n tiene suscritos con concesionarios nacionales.</li>
</ol>
<p>&nbsp;</p>
<ul>
<li><strong>&ldquo;Unidad de Tarificaci&oacute;n&rdquo;, </strong>es la unidad utilizada para medir el consumo agregado de un Cliente en el &aacute;rea de Cobertura de la Red Compartida en todos los tipos de tr&aacute;fico. Cada 1 MB de Datos, 1 Minuto de Voz entrante o saliente con destino nacional, o 1 SMS saliente con destino nacional en el &aacute;rea de Cobertura es equivalente a una &ldquo;Unidad de Tarificaci&oacute;n&rdquo;.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li><strong>&ldquo;Servicios de Tarificaci&oacute;n Adicional&rdquo;, </strong>son aquellos Servicios que se prestan con N&uacute;meros No Geogr&aacute;ficos que se utilizan con un prop&oacute;sito distinto al tradicional. Estos Servicios tienen el coste de Terminaci&oacute;n en la red del operador hu&eacute;sped, m&aacute;s el coste repercutido por el proveedor del Servicio de Tarificaci&oacute;n</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO contempla dos modalidades de Estructuras Tarifarias que se describen a continuaci&oacute;n:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li><strong>&ldquo;Estructura Tarifaria Granel&rdquo;, </strong>en la que el tr&aacute;fico de todos los Usuarios Finales del Cliente se tarifica mediante una Tarifa &uacute;nica para cada Servicio calculada en cada Periodo de Facturaci&oacute;n. Los Servicios de Datos, Voz, y/o SMS tienen, cada uno de ellos, su Tarifa espec&iacute;fica.</li>
</ol>
<p>&nbsp;</p>
<ol start="11">
<li><strong>&ldquo;Estructura Tarifaria de Productos Empaquetados con Margen Porcentual Fijo&rdquo;</strong>, en los que el Precio de Referencia se establece para cada paquete definido que incluye una determinada Cuota de Datos, Minutos de Voz y SMS para el consumo de cada Usuario Final en un Ciclo Individual seg&uacute;n las reglas espec&iacute;ficas de utilizaci&oacute;n y definidas para el Producto en el Ap&eacute;ndice 11.3 &ldquo;Tarifas MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;.</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>El tr&aacute;fico de Datos ser&aacute; contabilizado por sesiones de Datos sumando el tr&aacute;fico cursado por el Usuario Final en downlink (DL) y uplink (UL).</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El tr&aacute;fico de Voz ser&aacute; contabilizado por</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El tr&aacute;fico de SMS ser&aacute; contabilizado por eventos de hasta 160 caracteres alfanum&eacute;ricos. Los SMS no incluyen servicios masivos de distribuci&oacute;n de mensajes, generados por aplicaciones hacia personas y terminados en n&uacute;meros de Usuarios Finales (en adelante &ldquo;A2P&rdquo;). El tr&aacute;fico A2P no forma parte del presente Ap&eacute;ndice.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Las Estructuras Tarifarias que incluyan Datos no son de aplicaci&oacute;n para productos y servicios Machine to Machine (M2M), Internet of Things (IoT), Peer to Peer (P2P) o comunicaci&oacute;n en formato de Datos entre m&aacute;quinas y/o equipos</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Los Productos que incluyan Voz y/o SMS no son de aplicaci&oacute;n para servicios que por sus caracter&iacute;sticas pudieran ser considerados masivos, como centros de llamadas o conmutadores telef&oacute;nicos (PBX), entre otros. De la misma forma, el Cliente se hace responsable de evitar el mal uso del Servicio de Voz impidiendo, sin limitaciones, pr&aacute;cticas como simboxing o</li>
</ul>
<p>&nbsp;</p>
<h4><u>SEGUNDA. Estructura Tarifaria Granel</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong>Estructura Tarifaria Granel para el Tr&aacute;fico de Datos, Voz Saliente y SMS Saliente en Cobertura:</strong>
<ul>
<li>La Tarifa aplicable a cada Servicio en cada Periodo de Facturaci&oacute;n se determina en funci&oacute;n del tramo de consumo de Unidades de Tarificaci&oacute;n cursadas por los Usuarios Finales del Cliente, de acuerdo a lo que se indica en la Tabla</li>
</ul>
</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El importe mensual por facturar ser&aacute; igual al resultado de la suma del producto del consumo de cada Servicio por la Tarifa aplicable a dicho</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="5" width="645">
<p>&nbsp;</p>
<p><strong>Estructura Tarifaria Granel para el Tr&aacute;fico de Datos, Voz Saliente y SMS Saliente en Cobertura</strong></p>
</td>
</tr>
<tr>
<td width="156">
<p>M&iacute;nimo (Unidades de Tarificaci&oacute;n / Periodo</p>
<p>de Facturaci&oacute;n)</p>
</td>
<td width="156">
<p>M&aacute;ximo (Unidades de Tarificaci&oacute;n / Periodo</p>
<p>de Facturaci&oacute;n)</p>
</td>
<td width="111">
<p>Tarifa de Datos (MXN / MB)</p>
</td>
<td width="111">
<p>Tarifa de Voz Saliente (MXN /</p>
<p>Min)</p>
</td>
<td width="111">
<p>Tarifa de SMS Saliente (MXN /</p>
<p>SMS)</p>
</td>
</tr>
<tr>
<td width="156">
<p>[●]</p>
</td>
<td width="156">
<p>[●]</p>
</td>
<td width="111">
<p>[●]</p>
</td>
<td width="111">
<p>[●]</p>
</td>
<td width="111">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="156">
<p>&hellip;</p>
</td>
<td width="156">
<p>&hellip;</p>
</td>
<td width="111">
<p>&hellip;</p>
</td>
<td width="111">
<p>&hellip;</p>
</td>
<td width="111">
<p>&hellip;</p>
</td>
</tr>
<tr>
<td colspan="2" width="312">
<p>M&aacute;s de [●]</p>
</td>
<td width="111">
<p>[●]</p>
</td>
<td width="111">
<p>[●]</p>
</td>
<td width="111">
<p>[●]</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 1. Estructura Tarifaria Granel para el Tr&aacute;fico de Datos, Voz Saliente y SMS Saliente en Cobertura.</em></p>
<p><em>&nbsp;</em></p>
<h4>2.2.&nbsp;&nbsp;&nbsp;&nbsp; Estructura Tarifaria Granel del Servicio de Usuario Visitante, Tr&aacute;nsito y Terminaci&oacute;n</h4>
<ul>
<li>El tr&aacute;fico de Datos, Voz o SMS que los Usuarios Finales del Cliente inicien en cobertura de otras redes nacionales bajo acuerdos de Servicio de Usuario Visitante que Alt&aacute;n celebre con otros Operadores, generar&aacute; Tarifas por el Servicio de Usuario</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Este Servicio se pone a disposici&oacute;n del Cliente y ser&aacute; facturado por Alt&aacute;n al Cliente sumando los siguientes cargos:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>Los cargos bajo los acuerdos de Servicio de Usuario Visitante; y</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Los cargos por Tr&aacute;nsito y Terminaci&oacute;n de Voz y SMS en redes distintas de la Red Compartida.</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n facturar&aacute; con las Tarifas de la Estructura Tarifaria Granel para el Tr&aacute;fico de Datos, Voz Saliente y SMS Saliente en Cobertura, el Tr&aacute;fico cursado en Servicio de Usuario Visitante, siempre y cuando no exceda un [●] % como porcentaje del Tr&aacute;fico Total cursado por todos los Usuarios Finales del Cliente en cada Periodo de Facturaci&oacute;n. En caso de excederse este porcentaje, el consumo adicional se facturar&aacute; bajo la Estructura Tarifaria del Servicio de Usuario Visitante, Transito y Terminaci&oacute;n. Este beneficio aplicar&aacute; &uacute;nicamente cuando el Cliente haya elegido la Estructura Tarifaria Granel para el Tr&aacute;fico de Datos, Voz Saliente y SMS Saliente en Cobertura para la totalidad de sus Usuarios</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Si el Cliente ha elegido para sus Usuarios Finales la Estructura Tarifaria Granel para el Tr&aacute;fico de Datos, una vez alcanzado el Volumen de Datos del Producto contratado para un Usuario Final, el Cliente podr&aacute; activar el Consumo Excedente a Velocidad Reducida, dentro de la duraci&oacute;n de su Ciclo La cantidad de Datos incluidos en las distintas Modalidades de Consumo Excedente a Velocidad Reducida de la Tabla 2 siguiente, podr&aacute;n ser utilizados dentro del territorio nacional.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Cliente podr&aacute; elegir para cada Producto una de las siguientes modalidades de Consumo Excedente a Velocidad Reducida que se detallan en la Tabla 2 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="4" width="645">
<p><strong>Modalidades de Consumo Excedente a Velocidad Reducida para la Estructura Tarifaria Granel para el Tr&aacute;fico de Datos en territorio nacional</strong></p>
</td>
</tr>
<tr>
<td width="167">
<p>Velocidad (Kbps)</p>
</td>
<td width="159">
<p>Tarifa (MXN / GB)</p>
</td>
<td width="159">
<p>Cantidad de Datos (GB)</p>
</td>
<td width="161">
<p>Producto al que aplica</p>
</td>
</tr>
<tr>
<td width="167">
<p>[●]</p>
</td>
<td width="159">
<p>[●]</p>
</td>
<td width="159">
<p>[●]</p>
</td>
<td width="161">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="167">
<p>&hellip;</p>
</td>
<td width="159">
<p>&hellip;</p>
</td>
<td width="159">
<p>&hellip;</p>
</td>
<td width="161">
<p>&hellip;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 2: Modalidades de Consumo Excedente a Velocidad Reducida para la Estructura Tarifaria Granel para el Tr&aacute;fico de Datos en territorio nacional</em></p>
<p><em>&nbsp;</em></p>
<h4>2.3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Estructura Tarifaria Granel para el Servicio de Interconexi&oacute;n</h4>
<p><strong>&nbsp;</strong></p>
<p><strong>2.3.1 </strong>El Tr&aacute;fico originado desde los Usuarios Finales del Cliente que se curse hacia otras redes m&oacute;viles y/o fijas nacionales bajo acuerdos de Interconexi&oacute;n y/o Tr&aacute;nsito que Alt&aacute;n celebre con otros operadores nacionales generar&aacute; Tarifas de Interconexi&oacute;n. Este Servicio de Interconexi&oacute;n ser&aacute; facturado por Alt&aacute;n al Cliente de acuerdo con los cargos que Alt&aacute;n tenga en dichos acuerdos. Las Tarifas del Servicio de Interconexi&oacute;n se facturan de forma adicional a la Estructuras Tarifarias mencionadas en las Cl&aacute;usulas 2.1 del presente Ap&eacute;ndice.</p>
<p>&nbsp;</p>
<h4>2.4.&nbsp;&nbsp;&nbsp;&nbsp; Bono por llamadas de Voz y SMS entrantes</h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Para el caso de las llamadas de Voz y los SMS entrantes que tengan su origen en otros operadores m&oacute;viles y/o fijos nacionales y que generen un ingreso de interconexi&oacute;n para Alt&aacute;n, el Cliente recibir&aacute; un ingreso (en lo sucesivo &ldquo;Bono por llamadas de Voz y SMS entrantes&rdquo;) por este concepto. El Bono por llamadas de Voz y SMS entrantes ser&aacute; un porcentaje sobre el total del ingreso de interconexi&oacute;n correspondiente al tr&aacute;fico de Voz y SMS entrante con destino los Usuarios Finales del Cliente conforme a lo mencionado en la Tabla 3 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="646">
<p><strong>Bono por llamadas de Voz y SMS entrantes</strong></p>
</td>
</tr>
<tr>
<td width="191">
<p>Bono por llamadas de Voz y</p>
<p>SMS entrantes</p>
</td>
<td width="455">
<p>[●] % del monto obtenido por Interconexi&oacute;n por Llamadas y SMS Entrantes</p>
<p>a los Usuarios Finales del Cliente</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 3. Bono por llamadas de Voz y SMS entrantes.</em></p>
<p><em>&nbsp;</em></p>
<ul>
<li>Los SMS entrantes incluidos dentro de este esquema &uacute;nicamente se refieren a aquellos de modalidad persona a persona (en adelante &ldquo;P2P&rdquo;).</li>
</ul>
<p>&nbsp;</p>
<p><strong>2.4.3. </strong>El Bono por llamadas de Voz y SMS entrantes ser&aacute; aplicado, en cada Periodo de Facturaci&oacute;n, como un descuento sobre el monto a facturar por los conceptos de la Tabla 1. Este descuento no podr&aacute; ser mayor a un [●] % del monto a facturar por dichos conceptos. En caso de que el monto no pueda ser aplicado en su totalidad podr&aacute; ser descontado de una o varias de las siguientes facturas. En caso de existir una disputa relacionada con el tr&aacute;fico de interconexi&oacute;n que genere una diferencia en el ingreso de interconexi&oacute;n para Alt&aacute;n, que suponga una reducci&oacute;n del descuento por el concepto del Bono por llamadas de Voz y SMS entrantes, Alt&aacute;n podr&aacute; ajustar las siguientes facturas para corregir las diferencias; este ajuste deber&aacute; de suceder dentro de un plazo m&aacute;ximo de 90 d&iacute;as naturales desde la emisi&oacute;n de la factura correspondiente al mes donde se origin&oacute; el tr&aacute;fico.</p>
<p>&nbsp;</p>
<h4>2.5.&nbsp;&nbsp;&nbsp;&nbsp; Estructura Tarifaria Granel del Servicio de Roaming Internacional</h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El tr&aacute;fico de Datos, Voz o SMS que los Usuarios Finales del Cliente inicien o reciban en cobertura de otras redes fuera del territorio nacional bajo acuerdos de Roaming Internacional que Alt&aacute;n celebre con otros Operadores, generar&aacute; Tarifas por el Servicio de Roaming</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Este Servicio se pone a disposici&oacute;n del Cliente y ser&aacute; facturado por Alt&aacute;n seg&uacute;n el siguiente detalle de cargos:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>Los cargos a facturar cuando un Usuario Final se encuentra en Roaming Internacional y origina una llamada o un SMS, ser&aacute;n:</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Los cargos bajo los acuerdos de Roaming Internacional; y</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Los cargos por Terminaci&oacute;n y Tr&aacute;nsito de Voz y SMS en redes distintas de la Red Compartida cuando el destino est&aacute; en M&eacute;xico.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Los cargos a facturar cuando un Usuario Final se encuentra en Roaming Internacional y recibe una llamada, ser&aacute;n:</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Los cargos bajo los acuerdos de Roaming Internacional de llamada recibida; y</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Los cargos de</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Los cargos a facturar cuando un Usuario Final se encuentra en Roaming Internacional y recibe un SMS ser&aacute;n facturados de acuerdo a las tarifas</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Los cargos a facturar cuando un Usuario Final se encuentre en Roaming Internacional y realice una sesi&oacute;n de datos ser&aacute;n los correspondientes a los acuerdos de Roaming Internacional para el Servicio de</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>Las Tarifas de Roaming Internacional para cada Servicio ser&aacute;n comunicadas al Cliente a trav&eacute;s de la plataforma Web de Tarifas. En caso de cambio de estas, las nuevas tarifas ser&aacute;n aplicables y tendr&aacute;n efecto una vez transcurridos 30 (treinta) d&iacute;as desde la fecha en que Alt&aacute;n las</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>A las Tarifas aplicables para el tr&aacute;fico en Roaming Internacional para cada Servicio se les agregar&aacute; el cargo de gesti&oacute;n que se indica en la Tabla 4 siguiente:</li>
</ul>
<p>&nbsp;</p>
<p><em>Tabla 4. Estructura Tarifaria del Servicio de Roaming Internacional.</em></p>
<p><em>&nbsp;</em></p>
<h4>2.6.&nbsp;&nbsp;&nbsp;&nbsp; Estructura Tarifaria Granel para Larga Distancia Internacional</h4>
<p><strong>&nbsp;</strong></p>
<p><strong>2.6.1 </strong>Los Servicios de Larga Distancia Internacional (&ldquo;LDI&rdquo;) ser&aacute;n tarificados conforme a las Tarifas estipuladas en las Tablas 5 y 6 siguientes:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="646">
<p><strong>Estructura Tarifaria del Servicio de Voz LDI</strong></p>
</td>
</tr>
<tr>
<td width="336">
<p><strong>Destino / Regi&oacute;n</strong></p>
</td>
<td width="310">
<p><strong>Tarifa (MXN / Minuto)</strong></p>
</td>
</tr>
<tr>
<td width="336">
<p>Estados Unidos de Am&eacute;rica</p>
</td>
<td width="310">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="336">
<p>Canad&aacute;</p>
</td>
<td width="310">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="336">
<p>&hellip;</p>
</td>
<td width="310">
<p>[●]</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 5. Estructura Tarifaria del Servicio de Voz LDI.</em></p>
<p><em>&nbsp;</em></p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="646">
<p><strong>Estructura Tarifaria del Servicio de SMS Internacional</strong></p>
</td>
</tr>
<tr>
<td width="336">
<p><strong>Destino / Regi&oacute;n</strong></p>
</td>
<td width="310">
<p><strong>Tarifa (MXN /SMS)</strong></p>
</td>
</tr>
<tr>
<td width="336">
<p>Estados Unidos de Am&eacute;rica</p>
</td>
<td width="310">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="336">
<p>Canad&aacute;</p>
</td>
<td width="310">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="336">
<p>&hellip;</p>
</td>
<td width="310">
<p>[●]</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 6. Estructura Tarifaria del Servicio de SMS Internacional.</em></p>
<p><em>&nbsp;</em></p>
<ul>
<li>Alt&aacute;n podr&aacute; retirar del Ap&eacute;ndice 11.3 &ldquo;Tarifas MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo; aquellos Productos de la Clausula Segunda del presente Ap&eacute;ndice que considere necesario, previa notificaci&oacute;n al Cliente con</li>
</ul>
<ol start="2">
<li>i) 30 (treinta) d&iacute;as naturales de anticipaci&oacute;n a excepci&oacute;n de los Productos del numeral 2.1 y ii) con 90 (noventa) d&iacute;as naturales de anticipaci&oacute;n para los Productos del numeral 2.1. Estos Productos dejar&aacute;n de ser comercializables para nuevas altas totales o activaciones. No obstante, si existieran Usuarios Finales que tienen contratados estos Productos, Alt&aacute;n se compromete a mantener las condiciones para la renovaci&oacute;n del Ciclo Individual hasta extinguir el Periodo de Validez originalmente previsto para el Producto.</li>
</ol>
<p>&nbsp;</p>
<h4><u>TERCERA. Estructura Tarifaria Productos Empaquetados con Margen Porcentual Fijo</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Alt&aacute;n se encargar&aacute; de dise&ntilde;ar y mantener un portafolio de Productos y promociones para su comercializaci&oacute;n asegurando que este portafolio responde a las necesidades del mercado y las din&aacute;micas</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Cada Producto tendr&aacute; un Precio de Referencia. El Precio de Referencia de cada Producto estar&aacute; expresado en el Ap&eacute;ndice 11.3 &ldquo;Tarifas MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;. Este Precio de Referencia se utiliza exclusivamente para calcular la Tarifa mayorista a la que Alt&aacute;n facturar&aacute; el servicio seg&uacute;n se define en la cl&aacute;usula 7. El Cliente ser&aacute; responsable en todos los casos de definir el precio al que comercializa el Producto al Usuario Final.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Los Servicios y condiciones incluidos en cada Producto ser&aacute;n detallados en el Ap&eacute;ndice 11.3 &ldquo;Tarifas MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;. Cada Producto podr&aacute; incluir los elementos necesarios para su venta al Usuario Final, incluyendo sin limitar: Datos, Minutos de Voz salientes, SMS salientes, Datos para uso exclusivo en redes sociales (&ldquo;<strong>RRSS</strong>&rdquo;), servicio de Interconexi&oacute;n, servicio de Usuario Visitante, servicios de Roaming Internacional, servicios de Larga Distancia Internacional, entre</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Las Tarifas asociadas a cada Producto incluyen los cargos de gesti&oacute;n por el uso de la Plataforma</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Cliente podr&aacute; comercializar cada Producto durante el Periodo de Comercializaci&oacute;n seg&uacute;n se define en el Ap&eacute;ndice 11.3 &ldquo;Tarifas MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Los Productos, condiciones y Precios de Referencia se actualizar&aacute;n por Alt&aacute;n para mantener la competitividad en el mercado:</li>
</ul>
<p>&nbsp;</p>
<ol start="11">
<li>Los Productos comercializables bajo este esquema, junto con su Precio de Referencia, Margen Porcentual Fijo, Periodo de Comercializaci&oacute;n y Periodo de Validez, se registrar&aacute;n por Alt&aacute;n en el Ap&eacute;ndice 11.3 &ldquo;Tarifas MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;.</li>
</ol>
<p>&nbsp;</p>
<ol start="11">
<li>Alt&aacute;n podr&aacute; retirar del Ap&eacute;ndice 11.3 &ldquo;Tarifas MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo; aquellos Productos de la Clausula Tercera de este Ap&eacute;ndice que considere necesario, previa notificaci&oacute;n al Cliente con 90 (noventa) d&iacute;as naturales de anticipaci&oacute;n. Estos Productos dejar&aacute;n de ser comercializables para nuevas altas totales o activaciones. No obstante, si existieran Usuarios Finales que tienen contratados estos Productos, Alt&aacute;n se compromete a mantener las condiciones para la renovaci&oacute;n del Ciclo Individual hasta extinguir el Periodo de Validez originalmente previsto para el</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n facturar&aacute; al Cliente una Tarifa mayorista que se calcula descontando el Margen Porcentual Fijo definido para el Producto sobre el Precio de Esta Tarifa mayorista no incluye los impuestos aplicables en su caso, los cuales deber&aacute;n ser pagados por el Cliente de conformidad a las Leyes Aplicables.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Margen Porcentual Fijo depender&aacute; del Porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Las Partes acordar&aacute;n las medidas de gesti&oacute;n para el uso adecuado del Servicio de Usuario Visitante, de conformidad con el Ap&eacute;ndice 11.1 &ldquo;Alcance T&eacute;cnico Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Cliente podr&aacute; comercializar bajo la Estructura Tarifaria Productos Empaquetados con Margen Porcentual Fijo los Productos incluidos en la Tabla 7 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="5" width="646">
<p><strong>Productos Estructura Tarifaria Productos Empaquetados con Margen Porcentual Fijo</strong></p>
</td>
</tr>
<tr>
<td width="129">
<p>&nbsp;</p>
<p>Producto</p>
</td>
<td width="129">
<p>&nbsp;</p>
<p>Anexo de detalle de condiciones</p>
</td>
<td width="129">
<p>&nbsp;</p>
<p>Precio de Referencia (MXN)</p>
</td>
<td width="129">
<p>Margen Porcentual Fijo para Productos con Porcentaje de Consumo Fuera de</p>
<p>Huella &lt;= [●]</p>
</td>
<td width="129">
<p>Margen Porcentual Fijo para Productos con Porcentaje de Consumo Fuera de</p>
<p>Huella &gt; [●]</p>
</td>
</tr>
<tr>
<td width="129">
<p>[●]</p>
</td>
<td width="129">
<p>[●]</p>
</td>
<td width="129">
<p>[●]</p>
</td>
<td width="129">
<p>[●]</p>
</td>
<td width="129">
<p>[●]</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 7. Productos Estructura Tarifaria Productos Empaquetados con Margen Porcentual Fijo.</em></p>
<p><em>&nbsp;</em></p>
<p><em>&nbsp;</em></p>
<p>Para el caso de la Estructura Tarifaria Productos Empaquetados con Margen Porcentual Fijo, una vez alcanzados los vol&uacute;menes o l&iacute;mites establecidos para los servicios de Voz y SMS salientes en el Producto contratado para un Usuario Final, dentro de la duraci&oacute;n de su Ciclo Individual, el Consumo Excedente se tarificar&aacute; mediante la Estructura Tarifaria Granel seg&uacute;n el tipo de Consumo mencionada en la Cl&aacute;usula 2 anterior. En el caso del servicio de Datos dentro de territorio nacional, ser&aacute; necesario activar un nuevo Producto de los mencionados en la Tabla 7 anterior, adquirir un paquete de Consumo Excedente de la Tabla 8, o bien solicitar la activaci&oacute;n de alguna de las modalidades de Consumo Excedente a Velocidad Reducida incluidas en la Tabla 9, para reestablecer el servicio.</p>
<p>&nbsp;</p>
<ul>
<li>Los paquetes de Consumo Excedente disponibles para la Estructura Tarifaria Productos Empaquetados con Margen Porcentual Fijo son los indicados en la Tabla 8 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="5" width="646">
<p><strong>Paquetes de Consumo Excedente para la Estructura Tarifaria Productos Empaquetados con Margen Porcentual Fijo</strong></p>
</td>
</tr>
<tr>
<td width="129">
<p>&nbsp;</p>
<p>Paquete de Consumo Excedente</p>
</td>
<td width="129">
<p>&nbsp;</p>
<p>Anexo de detalle de condiciones</p>
</td>
<td width="129">
<p>&nbsp;</p>
<p>Precio de Referencia (MXN)</p>
</td>
<td width="129">
<p>Margen Porcentual Fijo para Paquetes de Consumo Excedente con</p>
<p>Porcentaje de</p>
</td>
<td width="129">
<p>Margen Porcentual Fijo para Paquetes de Consumo Excedente con</p>
<p>Porcentaje de</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="129">
<p>&nbsp;</p>
</td>
<td width="129">
<p>&nbsp;</p>
</td>
<td width="129">
<p>&nbsp;</p>
</td>
<td width="129">
<p>Consumo Fuera de Huella &lt;= [●]</p>
</td>
<td width="129">
<p>Consumo Fuera de Huella &gt; [●]</p>
</td>
</tr>
<tr>
<td width="129">
<p>[●]</p>
</td>
<td width="129">
<p>[●]</p>
</td>
<td width="129">
<p>[●]</p>
</td>
<td width="129">
<p>[●]</p>
</td>
<td width="129">
<p>[●]</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 8: Paquetes de Consumo Excedente para la Estructura Tarifaria Productos Empaquetados con Margen Porcentual Fijo</em></p>
<p><em>&nbsp;</em></p>
<ul>
<li>El Cliente podr&aacute; elegir para cada Producto una de las siguientes modalidades de Consumo Excedente a Velocidad Reducida en territorio nacional que se detallan en la Tabla 9 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="4" width="645">
<p><strong>Modalidades de Consumo Excedente a Velocidad Reducida para el Tr&aacute;fico de Datos en territorio nacional</strong></p>
</td>
</tr>
<tr>
<td width="167">
<p>Velocidad (Kbps)</p>
</td>
<td width="159">
<p>Tarifa (MXN / GB)</p>
</td>
<td width="159">
<p>Cantidad de Datos (GB)</p>
</td>
<td width="161">
<p>Producto al que aplica</p>
</td>
</tr>
<tr>
<td width="167">
<p>[●]</p>
</td>
<td width="159">
<p>[●]</p>
</td>
<td width="159">
<p>[●]</p>
</td>
<td width="161">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="167">
<p>&hellip;</p>
</td>
<td width="159">
<p>&hellip;</p>
</td>
<td width="159">
<p>&hellip;</p>
</td>
<td width="161">
<p>&hellip;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 9: Modalidades de Consumo Excedente a Velocidad Reducida para el Tr&aacute;fico de Datos en territorio nacional</em></p>
<p><em>&nbsp;</em></p>
<h4>3.13.&nbsp; M&aacute;rgenes Adicionales por desempe&ntilde;o</h4>
<p><strong>&nbsp;</strong></p>
<p>Adicionalmente al Margen Porcentual Fijo por Producto se otorgar&aacute; al Cliente un margen porcentual adicional de comercializaci&oacute;n por volumen de Ingresos de Referencia y un margen adicional por volumen de altas totales, por Periodo de Facturaci&oacute;n.</p>
<p>&nbsp;</p>
<h4>3.13.1.&nbsp; Margen Adicional por volumen de ingresos de referencia</h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Este margen se har&aacute; efectivo mediante la aplicaci&oacute;n de un descuento adicional en la factura mensual en funci&oacute;n del volumen generado por el Cliente de acuerdo con lo estipulado en la Tabla 10 Los ingresos de referencia ser&aacute;n calculados como la suma del producto de cada Precio de Referencia y el n&uacute;mero de Productos vendidos dentro del Periodo de Facturaci&oacute;n.</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="646">
<p><strong>Margen Adicional por volumen de ingresos de referencia</strong></p>
</td>
</tr>
<tr>
<td width="189">
<p><strong>Ingresos de referencia m&iacute;nimos (MXN / Periodo de Facturaci&oacute;n)</strong></p>
</td>
<td width="217">
<p><strong>Ingresos de referencia m&aacute;ximos (MXN / Periodo de Facturaci&oacute;n)</strong></p>
</td>
<td width="240">
<p>&nbsp;</p>
<p><strong>Margen Adicional (%)</strong></p>
</td>
</tr>
<tr>
<td width="189">
<p>[●]</p>
</td>
<td width="217">
<p>[●]</p>
</td>
<td width="240">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="189">
<p>[●]</p>
</td>
<td width="217">
<p>[●]</p>
</td>
<td width="240">
<p>[●]</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 10. Margen Adicional por volumen de ingresos de referencia</em></p>
<p><em>&nbsp;</em></p>
<ul>
<li>Este descuento adicional no ser&aacute; de aplicaci&oacute;n sobre los Productos que tengan un Porcentaje de Consumo Fuera de Huella Alt&aacute;n mayor a []%.</li>
</ul>
<p>&nbsp;</p>
<h4>3.13.2.&nbsp; Margen Adicional por volumen de altas totales por Periodo de Facturaci&oacute;n</h4>
<p>&nbsp;</p>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Este margen se har&aacute; efectivo mediante la aplicaci&oacute;n de un descuento en la factura mensual en funci&oacute;n del n&uacute;mero de altas totales alcanzadas por el Cliente en el Periodo de Facturaci&oacute;n.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Margen Adicional aplicable en cada Periodo de Facturaci&oacute;n se determina en funci&oacute;n del n&uacute;mero de altas totales alcanzadas por el Cliente en el Periodo de Facturaci&oacute;n, de acuerdo a lo que se indica en la Tabla</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="646">
<p><strong>Margen Adicional por volumen de altas totales</strong></p>
</td>
</tr>
<tr>
<td width="252">
<p><strong>Desde (Altas totales por Periodo de Facturaci&oacute;n)</strong></p>
</td>
<td width="252">
<p><strong>Hasta (Altas totales por Periodo de Facturaci&oacute;n)</strong></p>
</td>
<td width="142">
<p><strong>Margen Adicional (%)</strong></p>
</td>
</tr>
<tr>
<td width="252">
<p>[●]</p>
</td>
<td width="252">
<p>[●]</p>
</td>
<td width="142">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="252">
<p>[●]</p>
</td>
<td width="252">
<p>[●]</p>
</td>
<td width="142">
<p>[●]</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 11. Margen Adicional por volumen de altas totales</em></p>
<p><em>&nbsp;</em></p>
<p><strong>3.12.2.3. </strong>Este descuento adicional no ser&aacute; de aplicaci&oacute;n sobre los Productos que tengan un Porcentaje de Consumo Fuera de Huella Alt&aacute;n mayor a [●]%.</p>
<p>&nbsp;</p>
<h4><u>CUARTA. Servicios de Tarificaci&oacute;n Adicional</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El tr&aacute;fico de Voz y SMS que los Usuarios Finales del Cliente que termine en Servicios de Tarificaci&oacute;n Adicional, generar&aacute; Tarifas por el Servicio de Terminaci&oacute;n en Servicios de Tarificaci&oacute;n</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Este Servicio se pone a disposici&oacute;n del Cliente y ser&aacute; facturado por Alt&aacute;n al Cliente sumando a los cargos por Terminaci&oacute;n de Voz y SMS en Servicios de Tarificaci&oacute;n.</li>
</ul>
<p>&nbsp;</p>
<h4><u>QUINTA. Plataforma Mayorista</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Alt&aacute;n tarificar&aacute; al Cliente un cargo recurrente por Usuario Final en cada Periodo de Facturaci&oacute;n mensual por concepto de Servicio de gesti&oacute;n de Plataforma Mayorista de acuerdo con lo establecido en la Tabla 12 siguiente. Este cargo se aplicar&aacute; por cada Usuario Final que en el Periodo de Facturaci&oacute;n haya estado: i) Activo, ii) Suspendido de Tr&aacute;fico saliente conforme a los Estados de Suscripci&oacute;n definidos en el Ap&eacute;ndice 11.1 &ldquo;Alcance T&eacute;cnico Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;.</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="645">
<p><strong>Estructura Tarifaria por Servicio de gesti&oacute;n de Plataforma Mayorista</strong></p>
</td>
</tr>
<tr>
<td width="226">
<p>M&iacute;nimo (Usuarios Finales Activos)</p>
</td>
<td width="226">
<p>M&aacute;ximo (Usuarios Finales Activos)</p>
</td>
<td width="193">
<p>Tarifa Aplicable (MXN / Usuario Final/Mes)</p>
</td>
</tr>
<tr>
<td width="226">
<p>[●]</p>
</td>
<td width="226">
<p>[●]</p>
</td>
<td width="193">
<p>[●]</p>
</td>
</tr>
<tr>
<td colspan="2" width="452">
<p>M&aacute;s de [●]</p>
</td>
<td width="193">
<p>[●]</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 12. Estructura Tarifaria por Servicio de gesti&oacute;n de Plataforma Mayorista.</em></p>
<p>&nbsp;</p>
<p><em>&nbsp;</em></p>
<ul>
<li>Este cargo aplicar&aacute; &uacute;nicamente a los Usuarios Finales bajo la Estructura Tarifaria Granel, de acuerdo a lo mencionado en la Cl&aacute;usula</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Este cargo no aplica a Usuarios Finales con Productos bajo la Estructura Tarifaria Productos Empaquetados con Margen Porcentual Fijo que tengan Consumo Excedente tarificado bajo la Estructura Tarifaria</li>
</ul>
<p>&nbsp;</p>
<h4><u>SEXTA. Otras Estructuras Tarifarias y condiciones de uso del Producto</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong><u>Plataformas de servicio del Cliente</u></strong></li>
</ul>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El Cliente contar&aacute; con un L&iacute;mite M&aacute;ximo de Tr&aacute;fico Saliente de Voz con destino a Call Center y Plataformas de servicio del Cliente para todos sus Usuarios Finales a precio cero en cada periodo de facturaci&oacute;n, el cual ser&aacute; el resultado de multiplicar los [●] minutos asignados para este fin por la cantidad total de Usuarios en estado Activo y Suspendido del</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Volumen total del Tr&aacute;fico Saliente de Voz cuyo destino sea el Call Center del Cliente ylas Plataformas de servicio del Cliente (buz&oacute;n de voz, IVR, marcaciones cortas, entre otras), que resulte mayor al L&iacute;mite M&aacute;ximo de Tr&aacute;fico Saliente de Voz con destino a Call Center y Plataformas de servicio del Cliente, ser&aacute; tarificado bajo la Estructura Tarifaria Granel especificada en la cl&aacute;usula segunda del presente ap&eacute;ndice.</li>
</ul>
<p>&nbsp;</p>
<h4><u>S&Eacute;PTIMA. Terminales y SIMs</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>La adquisici&oacute;n, comprobaci&oacute;n y cualquier otro costo relacionado con las SIMs y terminales ser&aacute;n responsabilidad exclusiva del</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n no ser&aacute; responsable de la relaci&oacute;n contractual/comercial entre el Cliente y el fabricante, por lo que el Cliente renuncia irrevocablemente a hacer cualquier reclamo a Alt&aacute;n derivado de lo anterior y se obliga a indemnizar y sacar en paz y a salvo a Alt&aacute;n de cualquier reclamaci&oacute;n que pudiera presentar el fabricante en contra de Alt&aacute;n.</li>
</ul>
<p>&nbsp;</p>
<p>[EL RESTO DE LA P&Aacute;GINA ES INTENCIONALMENTE DEJADO EN BLANCO;</p>
<p>SIGUE P&Aacute;GINA DE FIRMAS]</p>
<p>&nbsp;</p>
<p>En prueba de conformidad y enteradas de su contenido y alcance legal, las Partes firman por triplicado el presente Ap&eacute;ndice, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de diciembre de 2021.</p>
<p>&nbsp;</p>
<h4>Alt&aacute;n</h4>
<p>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</p>
<p>&nbsp;</p>
<h4>Cliente</h4>
<p>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</p>
<p>&nbsp;</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
<p>&nbsp;</p>
<p>Por: Gabriel Cejudo Funes Cargo: Representante Legal</p>
<p>&nbsp;</p>
<p>Por: Miguel Adri&aacute;n &Aacute;lvarez Manzo <br />Cargo: Representante Legal</p>
<p>&nbsp;</p>
<p>AP&Eacute;NDICE 11.3 TARIFAS</p>
<p>MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO</p>
<p>&nbsp;</p>
<p>El presente documento es el Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo; al que se refiere el Anexo 11 &ldquo;Servicio Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN</p>
<p>PORCENTUAL FIJO&rdquo; del Contrato Marco de Prestaci&oacute;n de Servicios de Telecomunicaciones (junto con sus Anexos y Ap&eacute;ndices, el &ldquo;<strong>Contrato</strong>&rdquo;) celebrado entre las Partes el 7 de diciembre de 2021. Los t&eacute;rminos con inicial may&uacute;scula que se utilizan en el presente Ap&eacute;ndice tienen el significado que se les atribuye en el Contrato o en el propio Anexo 11 &ldquo;Servicios Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS&nbsp; EMPAQUETADOS&nbsp; CON MARGEN PORCENTUAL&nbsp; FIJO&rdquo; o&nbsp; este Ap&eacute;ndice, seg&uacute;n</p>
<p>corresponda. Para la interpretaci&oacute;n del presente Ap&eacute;ndice, las Partes se sujetar&aacute;n a lo estipulado en la cl&aacute;usula 1.4 del Contrato.</p>
<p>&nbsp;</p>
<h4>1.&nbsp;&nbsp;&nbsp; <u>PRIMERA. Objeto y consideraciones generales</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El presente Ap&eacute;ndice tiene como objeto definir los Productos disponibles y establecer las Tarifas acordadas entre Alt&aacute;n y el Cliente para la prestaci&oacute;n de los Servicios de conectividad m&oacute;vil sobre la Red Compartida para el Servicio Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Consideraciones Generales:</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Las Tarifas estar&aacute;n expresadas en Pesos Mexicanos (MXN) y no incluyen los impuestos aplicables en su caso, los cuales deber&aacute;n ser pagados por el Cliente de conformidad con las Leyes</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Las Tarifas para los Productos establecidos bajo el presente Ap&eacute;ndice ser&aacute;n v&aacute;lidas durante la Vigencia establecida, salvo solicitud del Cliente al amparo del apartado 3 inciso (c) de este Ap&eacute;ndice.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>De conformidad con lo establecido en la Cl&aacute;usula 14.2 del Contrato, las modificaciones a este Ap&eacute;ndice no requieren de aprobaci&oacute;n previa del IFT. Sin embargo, Alt&aacute;n presentar&aacute; al IFT este Ap&eacute;ndice para su registro previo a que sea v&aacute;lido y surta efectos.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n dar&aacute; publicidad y transparencia a las Tarifas entre sus clientes de acuerdo con lo que se indica a continuaci&oacute;n:</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Las Tarifas establecidas en este Ap&eacute;ndice ser&aacute;n publicadas por Alt&aacute;n en una carpeta espec&iacute;fica para el Servicio Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO ubicada en la Plataforma Web de Tarifas a la que tendr&aacute;n acceso restringido y seguro todos los clientes que tengan contratado el Servicio Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO dentro de los 5 (cinco) D&iacute;as</li>
</ul>
<p>&nbsp;</p>
<p>H&aacute;biles siguientes a su registro ante el IFT. Asimismo, el IFT tambi&eacute;n dispondr&aacute; de acceso a la citada Plataforma Web de Tarifas.</p>
<p>&nbsp;</p>
<ul>
<li>El identificador y la clave de acceso a la Plataforma Web de Tarifas ser&aacute;n entregadas por Alt&aacute;n a la persona designada por el Cliente en el mismo momento de la firma del presente Ap&eacute;ndice.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Cliente podr&aacute; solicitar, en todo momento dentro de la vigencia del Contrato, que le sean aplicadas las mejores Tarifas publicadas por Alt&aacute;n en la Plataforma Web de Tarifas, teniendo efectos dicha aplicaci&oacute;n a partir del D&iacute;a H&aacute;bil siguiente a la fecha de recepci&oacute;n por parte de Alt&aacute;n de dicha</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>En caso de un incremento en las Tarifas, Alt&aacute;n publicar&aacute; las nuevas Tarifas de acuerdo con lo establecido en los incisos (a) y (b) anteriores, sin embargo, las nuevas Tarifas ser&aacute;n aplicables y tendr&aacute;n efectos trascurridos 30 (treinta) D&iacute;as desde la fecha en que Alt&aacute;n las publique en la Plataforma Web de</li>
</ul>
<p>&nbsp;</p>
<h4>2.&nbsp;&nbsp;&nbsp; <u>SEGUNDA. Productos Comercializables y Tarifas aplicables</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Este Ap&eacute;ndice recoge en cada momento los productos comercializables en el Servicio Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO as&iacute; como las condiciones tarifar&iacute;as</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>En cualquier momento Alt&aacute;n podr&aacute; retirar de este Ap&eacute;ndice aquellos Productos que considere Estos Productos dejar&aacute;n de ser comercializables para nuevas altas o activaciones. No obstante, si existieran Usuarios Finales que tienen contratados estos Productos, Alt&aacute;n se compromete a mantener las condiciones para la renovaci&oacute;n del Ciclo Individual hasta extinguir el Periodo de Validez originalmente previsto para el Producto.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Cliente deber&aacute; elegir entre la Estructura Tarifaria Granel, de conformidad con la cl&aacute;usula tercera de este Ap&eacute;ndice, o la Estructura Tarifaria Productos Empaquetados con Margen Porcentual Fijo, de conformidad con la cl&aacute;usula cuarta de este Ap&eacute;ndice. La Estructura Tarifaria elegida ser&aacute; de aplicaci&oacute;n a todos los Usuarios Finales del Cliente, salvo en aquellos casos donde exista un acuerdo mutuo entre las</li>
</ul>
<p>&nbsp;</p>
<h4>3.&nbsp;&nbsp;&nbsp; <u>TERCERA. Estructura Tarifaria Granel</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong><u>Estructura Tarifaria Granel para el Tr&aacute;fico de Datos, Voz Saliente y SMS Saliente en Cobertura:</u></strong></li>
</ul>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td colspan="5" width="634">
<p><strong>Estructura Tarifaria Granel para el Tr&aacute;fico de Datos, Voz Saliente y SMS Saliente en Cobertura</strong></p>
</td>
</tr>
<tr>
<td width="163">
<p>M&iacute;nimo (Unidades de Tarificaci&oacute;n / Periodo de Facturaci&oacute;n)</p>
</td>
<td width="174">
<p>M&aacute;ximo (Unidades de Tarificaci&oacute;n / Periodo de Facturaci&oacute;n)</p>
</td>
<td width="99">
<p><strong>&nbsp;</strong></p>
<p>Tarifa Datos (MXN / MB)</p>
</td>
<td width="99">
<p>Tarifa Voz Saliente (MXN</p>
<p>/ Min)</p>
</td>
<td width="99">
<p>Tarifa SMS Saliente (MXN</p>
<p>/ SMS)</p>
</td>
</tr>
<tr>
<td width="163">
<p>0</p>
</td>
<td width="174">
<p>13,500,000</p>
</td>
<td width="99">
<p>0.0400</p>
</td>
<td width="99">
<p>0.0630</p>
</td>
<td width="99">
<p>0.0400</p>
</td>
</tr>
<tr>
<td width="163">
<p>13,500,001</p>
</td>
<td width="174">
<p>88,500,000</p>
</td>
<td width="99">
<p>0.0312</p>
</td>
<td width="99">
<p>0.0550</p>
</td>
<td width="99">
<p>0.0312</p>
</td>
</tr>
<tr>
<td width="163">
<p>88,500,001</p>
</td>
<td width="174">
<p>359,000,000</p>
</td>
<td width="99">
<p>0.0288</p>
</td>
<td width="99">
<p>0.0500</p>
</td>
<td width="99">
<p>0.0288</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td width="337">
<p>M&aacute;s de 359,000,000</p>
</td>
<td width="99">
<p>0.0240</p>
</td>
<td width="99">
<p>0.0430</p>
</td>
<td width="99">
<p>0.0240</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 1. Estructura Tarifaria Granel para el Tr&aacute;fico de Datos, Voz Saliente y SMS Saliente en Cobertura.</em></p>
<p><em>&nbsp;</em></p>
<h4>3.2.&nbsp; <u>Estructura Tarifaria Granel del Servicio de Usuario Visitante, Tr&aacute;nsito y Terminaci&oacute;n</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Alt&aacute;n facturar&aacute; con las Tarifas de la Estructura Tarifaria Granel para el Tr&aacute;fico de Datos, Voz Saliente y SMS Saliente en Cobertura, el Tr&aacute;fico cursado en Servicio de Usuario Visitante, siempre y cuando no exceda un <strong>5% </strong>como porcentaje del Tr&aacute;fico Total cursado por todos los Usuarios Finales del Cliente en cada Periodo de Facturaci&oacute;n. En caso de excederse este porcentaje, el consumo adicional se facturar&aacute; bajo la Estructura Tarifaria del Servicio de Usuario Visitante, Transito y Terminaci&oacute;n. Este beneficio aplicar&aacute; &uacute;nicamente cuando el Cliente haya elegido la Estructura Tarifaria Granel para el Tr&aacute;fico de Datos, Voz Saliente y SMS Saliente en Cobertura para la totalidad de sus Usuarios</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Cliente podr&aacute; elegir para cada Producto una de las siguientes modalidades de Consumo Excedente a Velocidad Reducida que se detallan en la Tabla 2 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="4" width="645">
<p><strong>Modalidades de Consumo Excedente a Velocidad Reducida para la Estructura Tarifaria Granel para el Tr&aacute;fico de Datos en territorio nacional</strong></p>
</td>
</tr>
<tr>
<td width="101">
<p>Velocidad (Kbps)</p>
</td>
<td width="114">
<p>Tarifa (MXN / GB)</p>
</td>
<td width="144">
<p>Cantidad de Datos (GB)</p>
</td>
<td width="286">
<p>Producto al que aplica</p>
</td>
</tr>
<tr>
<td width="101">
<p>128</p>
</td>
<td width="114">
<p>0.00</p>
</td>
<td width="144">
<p>0-2</p>
</td>
<td width="286">
<p>Volumen de control igual o mayor a 5,000 MB</p>
</td>
</tr>
<tr>
<td width="101">
<p>512</p>
</td>
<td width="114">
<p>0.00</p>
</td>
<td width="144">
<p>0-20</p>
</td>
<td width="286">
<p>Volumen de control igual o mayor a 20,000 MB</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 2: Modalidades de Consumo Excedente a Velocidad Reducida para la Estructura Tarifaria Granel para el Tr&aacute;fico de Datos en territorio nacional</em></p>
<p><em>&nbsp;</em></p>
<h4>3.3.&nbsp; <u>Bono por llamadas de Voz y SMS entrantes</u></h4>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="646">
<p><strong>Bono por llamadas de Voz y SMS entrantes</strong></p>
</td>
</tr>
<tr>
<td width="191">
<p>Bono por llamadas de Voz y SMS entrantes</p>
</td>
<td width="455">
<p><strong>50% </strong>del monto obtenido por Interconexi&oacute;n por Llamadas y SMS Entrantes a los Usuarios Finales del Cliente.</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 3. Bono por llamadas de Voz y SMS entrantes.</em></p>
<p><em>&nbsp;</em></p>
<p>3.3.1. El Bono por llamadas de Voz y SMS entrantes ser&aacute; aplicado, en cada Periodo de Facturaci&oacute;n, como un descuento sobre el monto a facturar por los conceptos de la Tabla 1. Este descuento no podr&aacute; ser mayor a un 50% del monto a facturar por dichos conceptos.</p>
<p>&nbsp;</p>
<h4>3.4.&nbsp; <u>Tarifas para la Estructura Tarifaria Granel del Servicio de Roaming Internacional</u></h4>
<p><strong>&nbsp;</strong></p>
<p>Las Tarifas de Roaming Internacional para cada Servicio ser&aacute;n comunicadas al Cliente a trav&eacute;s de la plataforma Web de Tarifas. En caso de cambio de estas, las nuevas tarifas ser&aacute;n aplicables y tendr&aacute;n efecto una vez transcurridos 30 (treinta) d&iacute;as desde la fecha en que Alt&aacute;n las publique.</p>
<p>&nbsp;</p>
<p><strong>3.4.1&nbsp;&nbsp;&nbsp; </strong>A las Tarifas aplicables para el tr&aacute;fico en Roaming Internacional para cada Servicio se les agregar&aacute; el cargo de gesti&oacute;n que se indica en la Tabla 4 siguiente:</p>
<p>&nbsp;</p>
<p><em>Tabla 4. Estructura Tarifaria del Servicio de Roaming Internacional.</em></p>
<p><em>&nbsp;</em></p>
<h4>3.5.&nbsp; <u>Estructura Tarifaria Granel para Larga Distancia Internacional</u></h4>
<p><strong>&nbsp;</strong></p>
<p>3.5.1. Los Servicios de Larga Distancia Internacional (&ldquo;LDI&rdquo;) ser&aacute;n tarificados conforme a las Tarifas estipuladas en las Tablas 5 y 6 siguientes:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="646">
<p><strong>Estructura Tarifaria del Servicio de Voz LDI</strong></p>
</td>
</tr>
<tr>
<td width="354">
<p><strong>Destino / Regi&oacute;n</strong></p>
</td>
<td width="291">
<p><strong>Tarifa (MXN / Minuto)</strong></p>
</td>
</tr>
<tr>
<td width="354">
<p>Estados Unidos de Am&eacute;rica</p>
</td>
<td width="291">
<p>0.065</p>
</td>
</tr>
<tr>
<td width="354">
<p>Canad&aacute;</p>
</td>
<td width="291">
<p>0.061</p>
</td>
</tr>
<tr>
<td width="354">
<p>LATAM Excl. Caribe</p>
</td>
<td width="291">
<p>1.30</p>
</td>
</tr>
<tr>
<td width="354">
<p>Caribe</p>
</td>
<td width="291">
<p>2.73</p>
</td>
</tr>
<tr>
<td width="354">
<p>Uni&oacute;n Europea</p>
</td>
<td width="291">
<p>2.63</p>
</td>
</tr>
<tr>
<td width="354">
<p>Resto de Europa</p>
</td>
<td width="291">
<p>2.76</p>
</td>
</tr>
<tr>
<td width="354">
<p>Resto del Mundo Excl. Destinos Especiales</p>
</td>
<td width="291">
<p>5.15</p>
</td>
</tr>
<tr>
<td width="354">
<p>Destinos Especiales</p>
</td>
<td width="291">
<p>5.32</p>
</td>
</tr>
<tr>
<td width="354">
<p>Satelital</p>
</td>
<td width="291">
<p>77.63</p>
</td>
</tr>
<tr>
<td width="354">
<p>Marcaciones Especiales</p>
</td>
<td width="291">
<p>6.29</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 5. Estructura Tarifaria del Servicio de Voz LDI.</em></p>
<p><em>&nbsp;</em></p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="624">
<p><strong>Estructura Tarifaria del Servicio de SMS Internacional</strong></p>
</td>
</tr>
<tr>
<td width="342">
<p><strong>Destino</strong></p>
</td>
<td width="282">
<p><strong>Tarifa (MXN / Minuto)</strong></p>
</td>
</tr>
<tr>
<td width="342">
<p>Estados Unidos de Am&eacute;rica</p>
</td>
<td width="282">
<p>0.02</p>
</td>
</tr>
<tr>
<td width="342">
<p>Canad&aacute;</p>
</td>
<td width="282">
<p>0.02</p>
</td>
</tr>
<tr>
<td width="342">
<p>LATAM Excl. Caribe</p>
</td>
<td width="282">
<p>1.32</p>
</td>
</tr>
<tr>
<td width="342">
<p>Caribe</p>
</td>
<td width="282">
<p>1.32</p>
</td>
</tr>
<tr>
<td width="342">
<p>Uni&oacute;n Europea</p>
</td>
<td width="282">
<p>1.45</p>
</td>
</tr>
<tr>
<td width="342">
<p>Resto de Europa</p>
</td>
<td width="282">
<p>1.43</p>
</td>
</tr>
<tr>
<td width="342">
<p>Resto del Mundo Excl. Destinos Especiales</p>
</td>
<td width="282">
<p>1.45</p>
</td>
</tr>
<tr>
<td width="342">
<p>Destinos Especiales</p>
</td>
<td width="282">
<p>13.23</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 6. Estructura Tarifaria del Servicio de SMS Internacional.</em></p>
<p><em>&nbsp;</em></p>
<h4>4.&nbsp;&nbsp;&nbsp; <u>CUARTA. Estructura Tarifaria Productos Empaquetados con Margen Porcentual Fijo</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El Cliente podr&aacute; comercializar bajo el esquema de Margen Porcentual Fijo los Productos incluidos en la Tabla 7 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="5" width="697">
<p><strong>Productos Estructura Tarifaria Productos Empaquetados con Margen Porcentual Fijo</strong></p>
</td>
</tr>
<tr>
<td width="171">
<p>&nbsp;</p>
<p><strong>Producto</strong></p>
</td>
<td width="207">
<p>&nbsp;</p>
<p><strong>Anexo de detalle de condiciones</strong></p>
</td>
<td width="98">
<p>&nbsp;</p>
<p><strong>Precio de Referencia</strong></p>
<p><strong>(MXN)</strong></p>
</td>
<td width="110">
<p><strong>Margen Porcentual Fijo para Productos con Porcentaje de Consumo Fuera de Huella</strong></p>
<p><strong>&le; 20%</strong></p>
</td>
<td width="110">
<p><strong>Margen Porcentual Fijo para Productos con Porcentaje de Consumo Fuera de Huella</strong></p>
<p><strong>&gt; 20%</strong></p>
</td>
</tr>
<tr>
<td width="171">
<p>100MB30D_RG</p>
</td>
<td width="207">
<p>1121-100MB30D_RG</p>
</td>
<td width="98">
<p>4.31</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>25%</p>
</td>
</tr>
<tr>
<td width="171">
<p>200MB30D_RG</p>
</td>
<td width="207">
<p>1121-200MB30D_RG</p>
</td>
<td width="98">
<p>8.62</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>25%</p>
</td>
</tr>
<tr>
<td width="171">
<p>500MB30D_RG</p>
</td>
<td width="207">
<p>1121-500MB30D_RG</p>
</td>
<td width="98">
<p>17.24</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>25%</p>
</td>
</tr>
<tr>
<td width="171">
<p>1000MB3D_ilim</p>
</td>
<td width="207">
<p>0621-1000MB3D_ilim</p>
</td>
<td width="98">
<p>25.86</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>25%</p>
</td>
</tr>
<tr>
<td width="171">
<p>2500MB7D_ilim</p>
</td>
<td width="207">
<p>0621-2500MB7D_ilim</p>
</td>
<td width="98">
<p>43.10</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>25%</p>
</td>
</tr>
<tr>
<td width="171">
<p>5000MB15D_ilim</p>
</td>
<td width="207">
<p>0621-5000MB15D_ilim</p>
</td>
<td width="98">
<p>86.21</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>25%</p>
</td>
</tr>
<tr>
<td width="171">
<p>2000MB3D_ilim</p>
</td>
<td width="207">
<p>0120-2000MB3D_ilim</p>
</td>
<td width="98">
<p>25.86</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>25%</p>
</td>
</tr>
<tr>
<td width="171">
<p>5000MB7D_ilim</p>
</td>
<td width="207">
<p>0120-5000MB7D_ilim</p>
</td>
<td width="98">
<p>43.10</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>25%</p>
</td>
</tr>
<tr>
<td width="171">
<p>10000MB15D_ilim</p>
</td>
<td width="207">
<p>0120-10000MB15D_ilim</p>
</td>
<td width="98">
<p>86.21</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>25%</p>
</td>
</tr>
<tr>
<td width="171">
<p>20000MB30D_ilim</p>
</td>
<td width="207">
<p>0120-20000MB30D_ilim</p>
</td>
<td width="98">
<p>172.41</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>25%</p>
</td>
</tr>
<tr>
<td width="171">
<p>2000MB3D_ilim2</p>
</td>
<td width="207">
<p>0820-2000MB3D_ilim2</p>
</td>
<td width="98">
<p>38.79</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>25%</p>
</td>
</tr>
<tr>
<td width="171">
<p>5000MB7D_ilim2</p>
</td>
<td width="207">
<p>0820-5000MB7D_ilim2</p>
</td>
<td width="98">
<p>64.66</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>25%</p>
</td>
</tr>
<tr>
<td width="171">
<p>10000MB15D_ilim2</p>
</td>
<td width="207">
<p>0820-10000MB15D_ilim2</p>
</td>
<td width="98">
<p>129.31</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>25%</p>
</td>
</tr>
<tr>
<td width="171">
<p>20000MB30D_ilim2</p>
</td>
<td width="207">
<p>0320-20000MB30D_ilim2</p>
</td>
<td width="98">
<p>258.62</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>25%</p>
</td>
</tr>
<tr>
<td width="171">
<p>50000MB30D_ilim</p>
</td>
<td width="207">
<p>0920-50000MB30D_ilim</p>
</td>
<td width="98">
<p>431.03</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>25%</p>
</td>
</tr>
<tr>
<td width="171">
<p>5000MB30D</p>
</td>
<td width="207">
<p>0120-5000MB30D</p>
</td>
<td width="98">
<p>86.21</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>25%</p>
</td>
</tr>
<tr>
<td width="171">
<p>8000MB30D</p>
</td>
<td width="207">
<p>0220-8000MB30D</p>
</td>
<td width="98">
<p>129.31</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>25%</p>
</td>
</tr>
<tr>
<td width="171">
<p>20000MB_Ilim_3m</p>
</td>
<td width="207">
<p>0920-20000MB_Ilim_3m</p>
</td>
<td width="98">
<p>474.14</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="171">
<p>20000MB_Ilim2_3m</p>
</td>
<td width="207">
<p>0920-20000MB_Ilim2_3m</p>
</td>
<td width="98">
<p>711.21</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="171">
<p>5000MB_ilim_6m_PA</p>
</td>
<td width="207">
<p>0621-5000MB_ilim_6m_PA</p>
</td>
<td width="98">
<p>344.83</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="171">
<p>20000MB_ilim_6m_PA</p>
</td>
<td width="207">
<p>0621-20000MB_ilim_6m_PA</p>
</td>
<td width="98">
<p>689.66</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="171">
<p>20000MB_ilim2_6m_PA</p>
</td>
<td width="207">
<p>0621-20000MB_ilim2_6m_PA</p>
</td>
<td width="98">
<p>1,034.48</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="171">
<p>5000MB_ilim_12m_PA</p>
</td>
<td width="207">
<p>0621-5000MB_ilim_12m_PA</p>
</td>
<td width="98">
<p>603.45</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="171">
<p>20000MB_ilim_12m_PA</p>
</td>
<td width="207">
<p>0621-20000MB_ilim_12m_PA</p>
</td>
<td width="98">
<p>1,206.90</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="171">
<p>20000MB_ilim2_12m_PA</p>
</td>
<td width="207">
<p>0621-20000MB_ilim2_12m_PA</p>
</td>
<td width="98">
<p>1,810.34</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="171">
<p>5000MB_ilim_24m_PA</p>
</td>
<td width="207">
<p>0921-5000MB_ilim_24m_PA</p>
</td>
<td width="98">
<p>1,637.93</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="171">
<p>20000MB_ilim_24m_PA</p>
</td>
<td width="207">
<p>0921-20000MB_ilim_24m_PA</p>
</td>
<td width="98">
<p>3,275.86</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="171">
<p>20000MB_ilim2_24m_PA</p>
</td>
<td width="207">
<p>0921-20000MB_ilim2_24m_PA</p>
</td>
<td width="98">
<p>4,913.79</p>
</td>
<td width="110">
<p>35%</p>
</td>
<td width="110">
<p>N/A</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="188">
<p>5000MB_2000MBRS30D</p>
</td>
<td width="207">
<p>0320-5000MB_2000MBRS30D</p>
</td>
<td width="93">
<p>120.69</p>
</td>
<td width="111">
<p>35%</p>
</td>
<td width="98">
<p>25%</p>
</td>
</tr>
<tr>
<td width="188">
<p>1000MB_300MBRS30D_NB28</p>
</td>
<td width="207">
<p>1220-1000MB_300MBRS30D_NB28</p>
</td>
<td width="93">
<p>86.21</p>
</td>
<td width="111">
<p>N/A</p>
</td>
<td width="98">
<p>20%</p>
</td>
</tr>
<tr>
<td width="188">
<p>2000MB_500MBRS30D_NB28</p>
</td>
<td width="207">
<p>1220-2000MB_500MBRS30D_NB28</p>
</td>
<td width="93">
<p>129.31</p>
</td>
<td width="111">
<p>N/A</p>
</td>
<td width="98">
<p>20%</p>
</td>
</tr>
<tr>
<td width="188">
<p>4000MB_2000MBRS30D_NB28</p>
</td>
<td width="207">
<p>1220-4000MB_2000MBRS30D_NB28</p>
</td>
<td width="93">
<p>258.62</p>
</td>
<td width="111">
<p>N/A</p>
</td>
<td width="98">
<p>20%</p>
</td>
</tr>
<tr>
<td width="188">
<p>10000MB7D_MiFi_BE</p>
</td>
<td width="207">
<p>0421-10000MB7D_MiFi_BE</p>
</td>
<td width="93">
<p>68.97</p>
</td>
<td width="111">
<p>40%</p>
</td>
<td width="98">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="188">
<p>20000MB7D_MiFi_BE</p>
</td>
<td width="207">
<p>0421-20000MB7D_MiFi_BE</p>
</td>
<td width="93">
<p>120.69</p>
</td>
<td width="111">
<p>40%</p>
</td>
<td width="98">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="188">
<p>5000MB30D_MiFi_BE</p>
</td>
<td width="207">
<p>0520-5000MB30D_MiFi_BE</p>
</td>
<td width="93">
<p>86.21</p>
</td>
<td width="111">
<p>40%</p>
</td>
<td width="98">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="188">
<p>10000MB30D_MiFi_BE</p>
</td>
<td width="207">
<p>0520-10000MB30D_MiFi_BE</p>
</td>
<td width="93">
<p>150.86</p>
</td>
<td width="111">
<p>40%</p>
</td>
<td width="98">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="188">
<p>20000MB30D_MiFi_BE</p>
</td>
<td width="207">
<p>0520-20000MB30D_MiFi_BE</p>
</td>
<td width="93">
<p>258.62</p>
</td>
<td width="111">
<p>40%</p>
</td>
<td width="98">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="188">
<p>30000MB30D_MiFi_BE</p>
</td>
<td width="207">
<p>0520-30000MB30D_MiFi_BE</p>
</td>
<td width="93">
<p>344.83</p>
</td>
<td width="111">
<p>40%</p>
</td>
<td width="98">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="188">
<p>50000MB30D_MiFi_BE</p>
</td>
<td width="207">
<p>0520-50000MB30D_MiFi_BE</p>
</td>
<td width="93">
<p>431.03</p>
</td>
<td width="111">
<p>40%</p>
</td>
<td width="98">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="188">
<p>80000MB30D_MiFi_BE</p>
</td>
<td width="207">
<p>0521-80000MB30D_MiFi_BE</p>
</td>
<td width="93">
<p>689.66</p>
</td>
<td width="111">
<p>40%</p>
</td>
<td width="98">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="188">
<p>100000MB30D_MiFi_BE</p>
</td>
<td width="207">
<p>0521-100000MB30D_MiFi_BE</p>
</td>
<td width="93">
<p>862.07</p>
</td>
<td width="111">
<p>40%</p>
</td>
<td width="98">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="188">
<p>10000MB7D_MiFi_BE_TN</p>
</td>
<td width="207">
<p>0421-10000MB7D_MiFi_BE_TN</p>
</td>
<td width="93">
<p>68.97</p>
</td>
<td width="111">
<p>35%</p>
</td>
<td width="98">
<p>25%</p>
</td>
</tr>
<tr>
<td width="188">
<p>20000MB7D_MiFi_BE_TN</p>
</td>
<td width="207">
<p>0421-20000MB7D_MiFi_BE_TN</p>
</td>
<td width="93">
<p>120.69</p>
</td>
<td width="111">
<p>35%</p>
</td>
<td width="98">
<p>25%</p>
</td>
</tr>
<tr>
<td width="188">
<p>5000MB30D_MiFi_BE_TN</p>
</td>
<td width="207">
<p>0520-5000MB30D_MiFi_BE_TN</p>
</td>
<td width="93">
<p>86.21</p>
</td>
<td width="111">
<p>35%</p>
</td>
<td width="98">
<p>25%</p>
</td>
</tr>
<tr>
<td width="188">
<p>10000MB30D_MiFi_BE_TN</p>
</td>
<td width="207">
<p>0520-10000MB30D_MiFi_BE_TN</p>
</td>
<td width="93">
<p>150.86</p>
</td>
<td width="111">
<p>35%</p>
</td>
<td width="98">
<p>25%</p>
</td>
</tr>
<tr>
<td width="188">
<p>20000MB30D_MiFi_BE_TN</p>
</td>
<td width="207">
<p>0520-20000MB30D_MiFi_BE_TN</p>
</td>
<td width="93">
<p>258.62</p>
</td>
<td width="111">
<p>35%</p>
</td>
<td width="98">
<p>25%</p>
</td>
</tr>
<tr>
<td width="188">
<p>30000MB30D_MiFi_BE_TN</p>
</td>
<td width="207">
<p>0520-30000MB30D_MiFi_BE_TN</p>
</td>
<td width="93">
<p>344.83</p>
</td>
<td width="111">
<p>35%</p>
</td>
<td width="98">
<p>25%</p>
</td>
</tr>
<tr>
<td width="188">
<p>50000MB30D_MiFi_BE_TN</p>
</td>
<td width="207">
<p>0520-50000MB30D_MiFi_BE_TN</p>
</td>
<td width="93">
<p>431.03</p>
</td>
<td width="111">
<p>35%</p>
</td>
<td width="98">
<p>25%</p>
</td>
</tr>
<tr>
<td width="188">
<p>80000MB30D_MiFi_BE_TN</p>
</td>
<td width="207">
<p>0521-80000MB30D_MiFi_BE_TN</p>
</td>
<td width="93">
<p>689.66</p>
</td>
<td width="111">
<p>35%</p>
</td>
<td width="98">
<p>25%</p>
</td>
</tr>
<tr>
<td width="188">
<p>100000MB30D_MiFi_BE_TN</p>
</td>
<td width="207">
<p>0521-100000MB30D_MiFi_BE_TN</p>
</td>
<td width="93">
<p>862.07</p>
</td>
<td width="111">
<p>35%</p>
</td>
<td width="98">
<p>25%</p>
</td>
</tr>
<tr>
<td width="188">
<p>1000MB_PDUV</p>
</td>
<td width="207">
<p>0920-1000MB_PDUV</p>
</td>
<td width="93">
<p>68.97</p>
</td>
<td width="111">
<p>N/A</p>
</td>
<td width="98">
<p>25%</p>
</td>
</tr>
<tr>
<td width="188">
<p>2000MB_PDUV</p>
</td>
<td width="207">
<p>0920-2000MB_PDUV</p>
</td>
<td width="93">
<p>137.93</p>
</td>
<td width="111">
<p>N/A</p>
</td>
<td width="98">
<p>25%</p>
</td>
</tr>
<tr>
<td width="188">
<p>5000MB_PDUV</p>
</td>
<td width="207">
<p>0920-5000MB_PDUV</p>
</td>
<td width="93">
<p>344.83</p>
</td>
<td width="111">
<p>N/A</p>
</td>
<td width="98">
<p>25%</p>
</td>
</tr>
<tr>
<td width="188">
<p>70U_PVSMSLDI</p>
</td>
<td width="207">
<p>0920-70U_PVSMSLDI</p>
</td>
<td width="93">
<p>86.21</p>
</td>
<td width="111">
<p>N/A</p>
</td>
<td width="98">
<p>15%</p>
</td>
</tr>
<tr>
<td width="188">
<p>40U_PVSMSLDIE</p>
</td>
<td width="207">
<p>0920-40U_PVSMSLDIE</p>
</td>
<td width="93">
<p>86.21</p>
</td>
<td width="111">
<p>N/A</p>
</td>
<td width="98">
<p>15%</p>
</td>
</tr>
<tr>
<td width="188">
<p>40U_PVSMSLDIRM</p>
</td>
<td width="207">
<p>0920-40U_PVSMSLDIRM</p>
</td>
<td width="93">
<p>172.41</p>
</td>
<td width="111">
<p>N/A</p>
</td>
<td width="98">
<p>15%</p>
</td>
</tr>
<tr>
<td width="188">
<p>25U_PVSMSLDIRM</p>
</td>
<td width="207">
<p>0920-25U_PVSMSLDIRM</p>
</td>
<td width="93">
<p>86.21</p>
</td>
<td width="111">
<p>N/A</p>
</td>
<td width="98">
<p>15%</p>
</td>
</tr>
<tr>
<td width="188">
<p>500MB_PDRI-LEUC</p>
</td>
<td width="207">
<p>0421-500MB_PDRI-LEUC</p>
</td>
<td width="93">
<p>300.86</p>
</td>
<td width="111">
<p>N/A</p>
</td>
<td width="98">
<p>20%</p>
</td>
</tr>
<tr>
<td width="188">
<p>500MB_PDRI-EAAO</p>
</td>
<td width="207">
<p>0421-500MB_PDRI-EAAO</p>
</td>
<td width="93">
<p>602.59</p>
</td>
<td width="111">
<p>N/A</p>
</td>
<td width="98">
<p>20%</p>
</td>
</tr>
<tr>
<td width="188">
<p>1000MB_PDRI-EAAO</p>
</td>
<td width="207">
<p>0421-1000MB_PDRI-EAAO</p>
</td>
<td width="93">
<p>861.21</p>
</td>
<td width="111">
<p>N/A</p>
</td>
<td width="98">
<p>20%</p>
</td>
</tr>
<tr>
<td width="188">
<p>1MB_PDRI-MUNDIAL</p>
</td>
<td width="207">
<p>1021-1MB_PDRI-MUNDIAL</p>
</td>
<td width="93">
<p>1.72</p>
</td>
<td width="111">
<p>N/A</p>
</td>
<td width="98">
<p>20%</p>
</td>
</tr>
<tr>
<td width="188">
<p>100U_PVSMSRI</p>
</td>
<td width="207">
<p>0920-100U_PVSMSRI</p>
</td>
<td width="93">
<p>343.97</p>
</td>
<td width="111">
<p>N/A</p>
</td>
<td width="98">
<p>20%</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p><em>Tabla 7. Productos Estructura Tarifaria Productos Empaquetados con Margen Porcentual Fijo.</em></p>
<p><em>&nbsp;</em></p>
<ul>
<li>Los paquetes de Consumo Excedente disponibles para la Estructura Tarifaria Productos Empaquetados con Margen Porcentual Fijo son los indicados en la Tabla 8 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="5" width="699">
<p><strong>Paquetes de Consumo Excedente para la Estructura Tarifaria Productos Empaquetados con Margen Porcentual Fijo</strong></p>
</td>
</tr>
<tr>
<td width="162">
<p>&nbsp;</p>
<p>Paquete de Consumo Excedente</p>
</td>
<td width="179">
<p>&nbsp;</p>
<p>Anexo de detalle de condiciones</p>
</td>
<td width="107">
<p>&nbsp;</p>
<p>Precio de Referencia (MXN)</p>
</td>
<td width="125">
<p>Margen Porcentual Fijo para Paquetes de Consumo Excedente con Porcentaje de</p>
<p>Consumo Fuera de Huella <strong>&le; </strong>20%</p>
</td>
<td width="125">
<p>Margen Porcentual Fijo para Paquetes de Consumo Excedente con Porcentaje de</p>
<p>Consumo Fuera de Huella &gt; 20%</p>
</td>
</tr>
<tr>
<td width="162">
<p>1000MB_PCED</p>
</td>
<td width="179">
<p>0920-1000MB_PCED</p>
</td>
<td width="107">
<p>25.86</p>
</td>
<td width="125">
<p>25%</p>
</td>
<td width="125">
<p>15%</p>
</td>
</tr>
<tr>
<td width="162">
<p>2500MB_PCED</p>
</td>
<td width="179">
<p>0920-2500MB_PCED</p>
</td>
<td width="107">
<p>43.10</p>
</td>
<td width="125">
<p>25%</p>
</td>
<td width="125">
<p>15%</p>
</td>
</tr>
<tr>
<td width="162">
<p>5000MB_PCED</p>
</td>
<td width="179">
<p>0920-5000MB_PCED</p>
</td>
<td width="107">
<p>86.20</p>
</td>
<td width="125">
<p>25%</p>
</td>
<td width="125">
<p>15%</p>
</td>
</tr>
<tr>
<td width="162">
<p>1000MB_PCEVDSMS</p>
</td>
<td width="179">
<p>0920-1000MB_PCEVDSMS</p>
</td>
<td width="107">
<p>43.10</p>
</td>
<td width="125">
<p>20%</p>
</td>
<td width="125">
<p>10%</p>
</td>
</tr>
<tr>
<td width="162">
<p>2500MB_PCEVDSMS</p>
</td>
<td width="179">
<p>0920-2500MB_PCEVDSMS</p>
</td>
<td width="107">
<p>86.20</p>
</td>
<td width="125">
<p>20%</p>
</td>
<td width="125">
<p>10%</p>
</td>
</tr>
<tr>
<td width="162">
<p>500M_PCEV</p>
</td>
<td width="179">
<p>0920-500M_PCEV</p>
</td>
<td width="107">
<p>43.10</p>
</td>
<td width="125">
<p>25%</p>
</td>
<td width="125">
<p>15%</p>
</td>
</tr>
<tr>
<td width="162">
<p>3D_TT</p>
</td>
<td width="179">
<p>0521-3D_TT</p>
</td>
<td width="107">
<p>12.93</p>
</td>
<td width="125">
<p>35%</p>
</td>
<td width="125">
<p>25%</p>
</td>
</tr>
<tr>
<td width="162">
<p>7D_TT</p>
</td>
<td width="179">
<p>0521-7D_TT</p>
</td>
<td width="107">
<p>21.55</p>
</td>
<td width="125">
<p>35%</p>
</td>
<td width="125">
<p>25%</p>
</td>
</tr>
<tr>
<td width="162">
<p>15D_TT</p>
</td>
<td width="179">
<p>0521-15D_TT</p>
</td>
<td width="107">
<p>43.10</p>
</td>
<td width="125">
<p>35%</p>
</td>
<td width="125">
<p>25%</p>
</td>
</tr>
<tr>
<td width="162">
<p>30D_TT</p>
</td>
<td width="179">
<p>0521-30D_TT</p>
</td>
<td width="107">
<p>86.21</p>
</td>
<td width="125">
<p>35%</p>
</td>
<td width="125">
<p>25%</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 8: Paquetes de Consumo Excedente para la Estructura Tarifaria Productos Empaquetados con Margen Porcentual Fijo</em></p>
<p><em>&nbsp;</em></p>
<ul>
<li>El Cliente podr&aacute; elegir para cada Producto una de las siguientes modalidades de Consumo Excedente a Velocidad Reducida en territorio nacional que se detallan en la Tabla 9 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="4" width="646">
<p><strong>Modalidades de Consumo Excedente a Velocidad Reducida para el Tr&aacute;fico de Datos en territorio nacional</strong></p>
</td>
</tr>
<tr>
<td width="167">
<p>Velocidad (Kbps)</p>
</td>
<td width="159">
<p>Tarifa (MXN / GB)</p>
</td>
<td width="159">
<p>Cantidad de Datos (GB)</p>
</td>
<td width="161">
<p>Producto al que aplica</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="167">
<p>&nbsp;</p>
<p>Desde 128 hasta 512</p>
</td>
<td width="159">
<p>&nbsp;</p>
<p>8.00</p>
</td>
<td rowspan="2" width="159">
<p>&nbsp;</p>
<p>De 0 a 100</p>
</td>
<td width="161">
<p>&nbsp;</p>
<p>Aplica para todos los productos ilimitados, a excepci&oacute;n del producto 50000MB30D_ilim.</p>
</td>
</tr>
<tr>
<td width="167">
<p>Desde 512 hasta 1,024</p>
</td>
<td width="159">
<p>12.00</p>
</td>
<td width="161">
<p>50000MB30D_ilim</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 9: Modalidades de Consumo Excedente a Velocidad Reducida para el Tr&aacute;fico de Datos en territorio nacional</em></p>
<p><em>&nbsp;</em></p>
<ul>
<li>Las Tarifas de la Tabla 9 aplicar&aacute;n siempre que el Porcentaje de Consumo Fuera de Huella del Producto al cual se asocia alguna de las Modalidades de Consumo Excedente sea <strong>&le; 20%. </strong>En caso de excederse este porcentaje el consumo ser&aacute; tarificado bajo la Estructura Tarifaria</li>
</ul>

<p>&nbsp;</p>
<h4>1.&nbsp;&nbsp;&nbsp; <u>QUINTA. M&aacute;rgenes adicionales por desempe&ntilde;o</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong>Margen Adicional por volumen de ingresos de referencia</strong></li>
</ul>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="646">
<p><strong>Margen Adicional por volumen de ingresos de referencia</strong></p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Ingresos de referencia m&iacute;nimos (MXN / Periodo de Facturaci&oacute;n)</strong></p>
</td>
<td width="204">
<p><strong>Ingresos de referencia m&aacute;ximos (MXN / Periodo de Facturaci&oacute;n)</strong></p>
</td>
<td width="256">
<p><strong>&nbsp;</strong></p>
<p><strong>Margen Adicional (%)</strong></p>
</td>
</tr>
<tr>
<td width="186">
<p>20,000,000</p>
</td>
<td width="204">
<p>40,000,000</p>
</td>
<td width="256">
<p>2.00%</p>
</td>
</tr>
<tr>
<td width="186">
<p>40,000,001</p>
</td>
<td width="204">
<p>85,000,000</p>
</td>
<td width="256">
<p>3.50%</p>
</td>
</tr>
<tr>
<td colspan="2" width="390">
<p>M&aacute;s de 85,000,000</p>
</td>
<td width="256">
<p>5.00%</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 10. Margen Adicional por volumen de ingresos de referencia</em></p>
<p><em>&nbsp;</em></p>
<p>5.1.1. Este descuento adicional no ser&aacute; de aplicaci&oacute;n sobre los Productos que tengan un Porcentaje de Consumo Fuera de Huella Alt&aacute;n mayor a <strong>20%</strong>.</p>
<p>&nbsp;</p>
<h4>1.2.&nbsp; Margen Adicional por volumen de altas totales por Periodo de Facturaci&oacute;n</h4>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="646">
<p><strong>Margen Adicional por volumen de altas totales</strong></p>
</td>
</tr>
<tr>
<td width="252">
<p><strong>Desde (Altas totales por Periodo de Facturaci&oacute;n)</strong></p>
</td>
<td width="252">
<p><strong>Hasta (Altas totales por Periodo de Facturaci&oacute;n)</strong></p>
</td>
<td width="142">
<p><strong>Margen Adicional (%)</strong></p>
</td>
</tr>
<tr>
<td width="252">
<p>0</p>
</td>
<td width="252">
<p>5,000</p>
</td>
<td width="142">
<p>0.00%</p>
</td>
</tr>
<tr>
<td width="252">
<p>5,001</p>
</td>
<td width="252">
<p>10,000</p>
</td>
<td width="142">
<p>1.00%</p>
</td>
</tr>
<tr>
<td width="252">
<p>10,001</p>
</td>
<td width="252">
<p>15,000</p>
</td>
<td width="142">
<p>2.00%</p>
</td>
</tr>
<tr>
<td width="252">
<p>15,001</p>
</td>
<td width="252">
<p>20,000</p>
</td>
<td width="142">
<p>3.00%</p>
</td>
</tr>
<tr>
<td width="252">
<p>20,001</p>
</td>
<td width="252">
<p>25,000</p>
</td>
<td width="142">
<p>4.00%</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p><strong>&nbsp;</strong></p>
<p><em>Tabla 11. Margen Adicional por volumen de altas totales</em></p>
<p><em>&nbsp;</em></p>
<p>5.2.1 Este descuento adicional no ser&aacute; de aplicaci&oacute;n sobre los Productos que tengan un Porcentaje de Consumo Fuera de Huella Alt&aacute;n mayor a <strong>20%</strong>.</p>
<p>&nbsp;</p>
<h4>2.&nbsp;&nbsp;&nbsp; <u>SEXTA. Plataforma Mayorista</u></h4>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="650">
<p><strong>Estructura Tarifaria por Servicio de Gesti&oacute;n de Plataforma Mayorista</strong></p>
</td>
</tr>
<tr>
<td width="215">
<p>M&iacute;nimo (Usuarios Finales Activos)</p>
</td>
<td width="223">
<p>M&aacute;ximo (Usuarios Finales Activos)</p>
</td>
<td width="212">
<p>Tarifa Aplicable (MXN / Usuario Final / Mes)</p>
</td>
</tr>
<tr>
<td width="215">
<p>0</p>
</td>
<td width="223">
<p>50,000</p>
</td>
<td width="212">
<p>7.00</p>
</td>
</tr>
<tr>
<td width="215">
<p>50,001</p>
</td>
<td width="223">
<p>120,000</p>
</td>
<td width="212">
<p>4.00</p>
</td>
</tr>
<tr>
<td width="215">
<p>120,001</p>
</td>
<td width="223">
<p>250,000</p>
</td>
<td width="212">
<p>4.00</p>
</td>
</tr>
<tr>
<td width="215">
<p>250,001</p>
</td>
<td width="223">
<p>400,000</p>
</td>
<td width="212">
<p>3.50</p>
</td>
</tr>
<tr>
<td width="215">
<p>400,001</p>
</td>
<td width="223">
<p>500,000</p>
</td>
<td width="212">
<p>3.50</p>
</td>
</tr>
<tr>
<td width="215">
<p>500,001</p>
</td>
<td width="223">
<p>850,000</p>
</td>
<td width="212">
<p>3.00</p>
</td>
</tr>
<tr>
<td colspan="2" width="438">
<p>M&aacute;s de 850,000</p>
</td>
<td width="212">
<p>3.00</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 12. Estructura Tarifaria por Servicio de Gesti&oacute;n de Plataforma Mayorista.</em></p>
<p><em>&nbsp;</em></p>
<h4>3.&nbsp;&nbsp;&nbsp; <u>S&Eacute;PTIMA. Otras Estructuras Tarifarias y condiciones de uso del Producto</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li><u>Plataformas de servicio del Cliente</u></li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Cliente contar&aacute; con un L&iacute;mite M&aacute;ximo de Tr&aacute;fico Saliente de Voz con destino a Call Center y Plataformas de servicio del Cliente para todos sus Usuarios Finales a precio cero en cada periodo de facturaci&oacute;n, el cual ser&aacute; el resultado de multiplicar los 7 minutos asignados para este fin por la cantidad total de Usuarios en estado Activo y Suspendido del</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Volumen total del Tr&aacute;fico Saliente de Voz cuyo destino sea el Call Center del Cliente y las Plataformas de servicio del Cliente (buz&oacute;n de voz, IVR, marcaciones cortas, entre otras), que resulte mayor al L&iacute;mite M&aacute;ximo de Tr&aacute;fico Saliente de Voz con destino a Call Center y Plataformas de servicio del Cliente, ser&aacute; tarificado bajo la Estructura Tarifaria Granel especificada en la cl&aacute;usula segunda del presente ap&eacute;ndice.</li>
</ul>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADO EN BLANCO; SIGUE P&Aacute;GINA DE FIRMAS]</p>
<p>&nbsp;</p>
<p>En prueba de conformidad y enteradas las Partes de su contenido y alcance legal, las Partes firman por triplicado el presente Ap&eacute;ndice, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de diciembre de 2021.</p>
<p>&nbsp;</p>
<h4>Alt&aacute;n</h4>
<p>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</p>
<p>&nbsp;</p>
<h4>Cliente</h4>
<p>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</p>
<p>&nbsp;</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
<p>&nbsp;</p>
<p>Por: Gabriel Cejudo Funes Cargo: Representante Legal</p>
<p>&nbsp;</p>
<p>Por: Miguel Adri&aacute;n &Aacute;lvarez Manzo Cargo: Representante Legal</p>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 1121-100MB30D_RG]</p>
<p>&nbsp;</p>
<h3>ANEXO 1121-100MB30D_RG</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 100MB30D_RG incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>5.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>4.31 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos para Rating Group (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>100</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute; y para el uso exclusivo en el rating group configurado por el Cliente.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>25</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 1121-200MB30D_RG</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 200MB30D_RG incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>10.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>8.62 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos para Rating Group (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>200</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute; y para el uso exclusivo en el rating group configurado por el Cliente.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>50</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 1121-500MB30D_RG</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 500MB30D_RG incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>20.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>17.24 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos para Rating Group (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute; y para el uso exclusivo en el rating group configurado por el Cliente.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>75</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0621-1000MB3D_ilim</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 1000MB3D_ilim incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>30.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>25.86 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>3 d&iacute;as</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>1,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>125</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>125</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>63</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0621-2500MB7D_ilim]</p>
<p>&nbsp;</p>
<h3>ANEXO 0621-2500MB7D_ilim</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 2500MB7D_ilim incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>50.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>43.10 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>7 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre una semana</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>2,500</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>1,250</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>1,250</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>125</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0621-5000MB15D_ilim]</p>
<p>&nbsp;</p>
<h3>ANEXO 0621-5000MB15D_ilim</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 5000MB15D_ilim incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>100.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>86.21 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>15 d&iacute;as</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>2,500</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>2,500</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>1,000</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0120-2000MB3D_ilim]</p>
<p>&nbsp;</p>
<h3>ANEXO 0120-2000MB3D_ilim</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 2000MB3D_ilim incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>30.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>25.86 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>3 d&iacute;as</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>2,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>2,000</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, no podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>125</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>125</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>75</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0120-5000MB7D_ilim]</p>
<p>&nbsp;</p>
<h3>ANEXO 0120-5000MB7D_ilim</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 5000MB7D_ilim incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>50.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>43.10 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>7 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre una semana</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>1,250</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, no podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>125</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0120-10000MB15D_ilim]</p>
<p>&nbsp;</p>
<h3>ANEXO 0120-10000MB15D_ilim</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 10000MB15D_ilim incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>100.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>86.21 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>15 d&iacute;as</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>10,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>2,500</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>10,000</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, no podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>1,000</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0120-20000MB30D_ilim]</p>
<p>&nbsp;</p>
<h3>ANEXO 0120-20000MB30D_ilim</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al Producto 20000MB30D_ilim incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>200.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>172.41 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, no podr&aacute;n ser compartidos (funcionalidad de compartici&oacute;n de Datos, com&uacute;nmente conocida</p>
<p>como &ldquo;<em>Hotspot</em>&rdquo; o &ldquo;<em>Tethering</em>&rdquo;).</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>1,500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>750</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>1,000</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO, SIGUE EN ANEXO 0820-2000MB3D_ilim2]</p>
<p>&nbsp;</p>
<h3>ANEXO 0820-2000MB3D_ilim2</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 2000MB3D_ilim2 incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>45.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>38.79 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>3 d&iacute;as</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>2,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>2,000</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>125</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>125</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>75</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0820-5000MB7D_ilim2]</p>
<p>&nbsp;</p>
<h3>ANEXO 0820-5000MB7D_ilim2</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 5000MB7D_ilim2 incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>75.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>64.66 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>7 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre una semana</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>1,250</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>125</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0820-10000MB15D_ilim2]</p>
<p>&nbsp;</p>
<h3>ANEXO 0820-10000MB15D_ilim2</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 10000MB15D_ilim2 incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>150.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>129.31 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>15 d&iacute;as</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>10,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>2,500</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>10,000</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>1,000</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO EN 0320-20000MB30D_ilim2]</p>
<p>&nbsp;</p>
<h3>ANEXO 0320-20000MB30D_ilim2</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al Producto 20000MB30D_ilim2 incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>300.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>258.62 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad de compartici&oacute;n de Datos, com&uacute;nmente conocida como</p>
<p>&ldquo;<em>Hotspot</em>&rdquo; o &ldquo;<em>Tethering</em>&rdquo;).</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>1,500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>750</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>1,000</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO EN 0920-50000MB30D_ilim]</p>
<p>&nbsp;</p>
<h3>ANEXO 0920-50000MB30D_ilim</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al Producto 50000MB30D_ilim incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>500.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>431.03 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>50,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>50,000</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 1 Mbps.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad de compartici&oacute;n de Datos, com&uacute;nmente conocida como</p>
<p>&ldquo;<em>Hotspot</em>&rdquo; o &ldquo;<em>Tethering</em>&rdquo;).</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>10,000</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>10,000</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0120-5000MB30D]</p>
<p>&nbsp;</p>
<h3>ANEXO 0120-5000MB30D</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 5000MB30D incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>100.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>86.21 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de [●] Kbps.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>1,500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>750</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0220-8000MB30D]</p>
<p>&nbsp;</p>
<h3>ANEXO 0220-8000MB30D</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 8000MB30D incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>150.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>129.31 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>8,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de [●] Kbps.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>1,500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>750</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="136">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="438">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO, SIGUE EN ANEXO 0920-20000MB_Ilim_3m]</p>
<p>&nbsp;</p>
<h3>ANEXO 0920-20000MB_Ilim_3m</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 20000MB_Ilim_3m incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="165">
<p>550.00 MXN</p>
</td>
<td width="299">
<p>Contrataci&oacute;n de una l&iacute;nea para 3 meses continuos de servicio.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="165">
<p>474.14 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="165">
<p>30 d&iacute;as o una fecha inicio una fecha fin entre la que transcurre un mes calendario.</p>
</td>
<td width="299">
<p>A partir de su activaci&oacute;n esta oferta tendr&aacute; 2 renovaciones autom&aacute;ticas en las que se asignar&aacute;n nuevamente los vol&uacute;menes correspondientes a los servicios de Datos, Voz y SMS.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un Paquete de Consumo Excedente, y/o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>No Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, no podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>1,500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) solicitar que se ejecute una acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>750</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>1,000</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="164">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0920-20000MB_Ilim2_3m]</p>
<p>&nbsp;</p>
<h3>ANEXO 0920-20000MB_Ilim2_3m</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 20000MB_Ilim2_3m incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="165">
<p>825.00 MXN</p>
</td>
<td width="299">
<p>Contrataci&oacute;n de una l&iacute;nea para 3 meses continuos de servicio.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="165">
<p>711.21 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="165">
<p>30 d&iacute;as o una fecha inicio una fecha fin entre la que transcurre un mes calendario.</p>
</td>
<td width="299">
<p>A partir de su activaci&oacute;n esta oferta tendr&aacute; 2 renovaciones autom&aacute;ticas en las que se asignar&aacute;n nuevamente los vol&uacute;menes correspondientes a los servicios de Datos, Voz y SMS.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un Paquete de Consumo Excedente, y/o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>1,500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) solicitar que se ejecute una acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>750</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>1,000</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="164">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0621-5000MB_ilim_6m_PA]</p>
<p>&nbsp;</p>
<h3>ANEXO 0621-5000MB_ilim_6m_PA</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 5000MB_ilim_6m_PA incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="165">
<p>400.00 MXN</p>
</td>
<td width="299">
<p>Contrataci&oacute;n de una l&iacute;nea para 6 meses continuos de servicio.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="165">
<p>344.83 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="165">
<p>30 d&iacute;as o una fecha inicio una fecha fin entre la que transcurre un mes calendario.</p>
</td>
<td width="299">
<p>A partir de su activaci&oacute;n esta oferta tendr&aacute; 5 renovaciones autom&aacute;ticas en las que se asignar&aacute;n nuevamente los vol&uacute;menes correspondientes a los servicios de Datos, Voz y SMS.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un Paquete de Consumo Excedente, y/o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>1,500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>750</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="164">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp; </p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0621-20000MB_ilim_6m_PA]</p>
<p>&nbsp;</p>
<h3>ANEXO 0621-20000MB_ilim_6m_PA</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 20000MB_ilim_6m_PA incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>

  </div>
</template>

<script>
export default {
}
</script>
